<template>
  <div class="filter-wrapper studio-new">
    <v-form>
      <div class="studio-top-heading pb-2">
        <div class="d-flex align-center justify-space-between w-100">
          <h6>Plot</h6>
          <v-btn v-if="selectedSavedChartName != null" variant class="save-btn studio-btn text-none"
            @click="resetChartData">
            <img :src="addDashboard" alt="add" width="12px" height="12px" />
            <h6>Create</h6>
          </v-btn>
        </div>
      </div>
      
      <v-row no-gutters>
        <v-col cols="12" class="studio-input-form" v-if="isFluidsDataStudio || isDashboard">
          <v-row no-gutters style="width: 100%;">
            <!-- Plot Title removed - now handled in top bar -->
            
            <!-- Test Type -->
            <v-col cols="12" class="pa-0">
              <label for="">Test Type</label>
              <v-select variant="solo" class="custom-field" v-model="selectedTableTypeName"
                :items="filteredTableTypesNames" placeholder="Test Type" @update:modelValue="tableTypeChange"
                hide-details>
                <!-- Search Input + loader -->
                <template #prepend-item>
                  <v-text-field variant="solo" class="custom-field mx-4" v-model="tableTypeSearchQuery"
                    placeholder="Test Type" dense outlined clearable @input="filterTableTypeList"
                    @click:clear="resetTableTypeList" hide-details></v-text-field>
                  <div class="loader-container" v-if="loadingTableType">
                    <v-progress-circular indeterminate color="black" class="loaders"></v-progress-circular>
                  </div>
                </template>
                <template #no-data>
                  <v-list-item v-if="!loadingTableType">
                    <v-list-item-content>No data available</v-list-item-content>
                  </v-list-item>
                </template>
                <template #selection="{ item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" class="text-truncate">{{ item.title }}</span>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
                <template #item="{ props, item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <div v-bind="props" class="dropdown-item" @click="props.onClick">
                        <span v-bind="tooltipProps" class="text-truncate">{{ item.title }}</span>
                      </div>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
            
            <!-- Plot Type -->
            <v-col cols="12" class="pa-0">
              <label for="">Plot Type</label>
              <v-select variant="solo" class="custom-field" v-model="selectedChartTypeName"
                :items="filteredChartTypesNames" placeholder="Plot Type" @update:modelValue="chartTypeChange"
                :disabled="selectedTableTypeName === null" hide-details>
                <!-- Search Input + loader -->
                <template #prepend-item>
                  <v-text-field variant="solo" class="custom-field mx-4" v-model="chartTypeSearchQuery"
                    placeholder="Plot Type" dense outlined clearable @input="filterChartTypeList"
                    @click:clear="resetChartTypeList" hide-details></v-text-field>
                  <div class="loader-container" v-if="loadingChartType">
                    <v-progress-circular indeterminate color="black" class="loaders"></v-progress-circular>
                  </div>
                </template>
                <template #no-data>
                  <v-list-item v-if="!loadingChartType">
                    <v-list-item-content>No data available</v-list-item-content>
                  </v-list-item>
                </template>
                <template #selection="{ item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" class="text-truncate">{{ item.title }}</span>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
                <template #item="{ props, item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <div v-bind="props" class="dropdown-item" @click="props.onClick">
                        <span v-bind="tooltipProps" class="text-truncate">{{ item.title }}</span>
                      </div>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
            
            <!-- X-Axis Selection -->
            <v-col cols="12" class="px-0 pt-2 pb-0" v-if="showXAxis">
              <div class="d-flex align-center justify-space-between">
                <label for="">X-Axis Column</label>
                <div v-if="selectedChartTypeName === 'Line Plot' || selectedChartTypeName === 'Scatter Plot'" class="tab-div justify-space-between">
                  <v-btn-toggle v-model="isXLog" class="axis-toggle" mandatory @update:modelValue="handleXScaleToggleChange">
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                    <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                  </v-btn-toggle>
                </div>
              </div>
              <v-select variant="solo" class="custom-field" v-model="selectedXAxisKey"
                :items="filteredXAxisItems" item-title="displayName" item-value="name"
                placeholder="X-Axis Column" @update:modelValue="handleXSelection" hide-details>
                <!-- Search Input + loader -->
                <template #prepend-item>
                  <v-text-field variant="solo" class="custom-field mx-4" v-model="xAxisSearchQuery"
                    placeholder="Search X-Axis Column" dense outlined clearable @input="filterXAxisList"
                    @click:clear="resetXAxisList" hide-details></v-text-field>
                  <div class="loader-container" v-if="loadingXAxisData">
                    <v-progress-circular indeterminate color="black" class="loaders"></v-progress-circular>
                  </div>
                </template>
                <template #no-data>
                  <v-list-item v-if="!loadingXAxisData">
                    <v-list-item-content>No data available</v-list-item-content>
                  </v-list-item>
                </template>
                <template #selection="{ item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" class="text-truncate">{{ item.title }}</span>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
                <template #item="{ props, item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <div v-bind="props" class="dropdown-item" @click="props.onClick">
                        <span v-bind="tooltipProps" class="text-truncate">{{ item.title }}</span>
                      </div>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
            
            <!-- Y-Axis Selection -->
            <v-col cols="12" class="px-0 py-2" v-if="showYAxis">
              <div class="d-flex align-center justify-space-between">
                <label for="">Y-Axis Column(s)</label>
                <div v-if="selectedChartTypeName === 'Line Plot' || selectedChartTypeName === 'Scatter Plot'" class="tab-div justify-space-between">
                  <v-btn-toggle v-model="isYLog" class="axis-toggle" mandatory @update:modelValue="handleYScaleToggleChange">
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                    <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                  </v-btn-toggle>
                </div>
              </div>
              <v-select variant="solo" v-model="selectedYAxisKey" :items="filteredYAxisItems" multiple chips clearable
                closable-chips placeholder="Y-Axis Column(s)" item-title="displayName" item-value="name"
                :return-object="false" @update:modelValue="handleYSelection" class="custom-y-axis-chips custom-field" hide-details>
                <!-- Search Input + loader -->
                <template #prepend-item>
                  <v-text-field variant="solo" class="custom-field mx-4" v-model="yAxisSearchQuery"
                    placeholder="Search Y-Axis Column" dense outlined clearable @input="filterYAxisList"
                    @click:clear="resetYAxisList" hide-details></v-text-field>
                  <div class="loader-container" v-if="loadingYAxisData">
                    <v-progress-circular indeterminate color="black" class="loaders"></v-progress-circular>
                  </div>
                </template>
                <template #no-data>
                  <v-list-item v-if="!loadingYAxisData">
                    <v-list-item-content>No data available</v-list-item-content>
                  </v-list-item>
                </template>
                <template #selection="{ item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" class="text-truncate">{{ item.title }}</span>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
                <template #item="{ props, item }">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <div v-bind="props" class="dropdown-item" @click="props.onClick">
                        <span v-bind="tooltipProps" class="text-truncate">{{ item.title }}</span>
                      </div>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
            
            <!-- Z-Axis Selection -->
            <v-col cols="12" class="pa-0" v-if="showZAxis">
              <label for="">Z-Axis Column</label>
              <v-select variant="solo" class="custom-field" v-model="selectedZAxisKey" placeholder="Z-Axis Column"
                :items="filteredZAxisItems" item-title="displayName" item-value="name" @update:modelValue="handleZSelection" hide-details>
                <!-- Search Input + loader -->
                <template #prepend-item>
                  <v-text-field v-model="zAxisSearchQuery" placeholder="Search Z-Axis Column" dense outlined clearable
                    @input="filterZAxisList" @click:clear="resetZAxisList" hide-details></v-text-field>
                  <div class="loader-container" v-if="loadingZAxisData">
                    <v-progress-circular indeterminate color="black" class="loaders"></v-progress-circular>
                  </div>
                </template>
                <template #no-data>
                  <v-list-item v-if="!loadingZAxisData">
                    <v-list-item-content>No data available</v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            
            <!-- Color Group/Legend Selection -->
            <v-col cols="12" class="pa-0" v-if="showColorGroup">
              <label for="">Legend</label>
              <v-select variant="solo" class="custom-field" v-model="selectedColorGroupKey" clearable placeholder="Legend"
                :items="filteredColorGroupItems" item-title="displayName" item-value="name" @update:modelValue="handleColorGroupSelection" hide-details>
                <!-- Search Input + loader -->
                <template #prepend-item>
                  <v-text-field v-model="colorGroupSearchQuery" placeholder="Search Legend" dense outlined clearable
                    @input="filterColorGroupList" @click:clear="resetColorGroupList" hide-details></v-text-field>
                  <div class="loader-container" v-if="loadingZAxisData">
                    <v-progress-circular indeterminate color="black" class="loaders"></v-progress-circular>
                  </div>
                </template>
                <template #no-data>
                  <v-list-item v-if="!loadingZAxisData">
                    <v-list-item-content>No data available</v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            
            <!-- X-Bins Input -->
            <v-col cols="12" class="pa-0" v-if="showXBinsInput">
              <label for="">Number of X bins</label>
              <div id="rangeValue">{{ xBinsAsNumber }}</div>
              <input type="range" id="rangeInput" class="slider" min="2" max="100" step="1" v-model="xBins" @input="updateXBins" />
            </v-col>
            
            <!-- Y-Bins Input -->
            <v-col cols="12" class="pa-0" v-if="showYBinsInput">
              <label for="">Number of Y bins</label>
              <div id="rangeValue">{{ yBinsAsNumber }}</div>
              <input type="range" id="rangeInput" class="slider" min="2" max="100" step="1" v-model="yBins" @input="updateYBins" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      
      <!-- Additional components -->
      <v-col v-if="$route.name === 'DataInventoryAnalysis'" cols="12" class="pa-0">
        <label for="">Select Saved Dashboard</label>
        <v-select v-model="dashboard" placeholder="Select Saved Dashboard" :items="dashboardItems"
          @update:modelValue="handleDshboardSelection">
          <template #selection="{ item }">
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <span v-bind="props" class="text-truncate">{{ item.title }}</span>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </template>
          <template #item="{ props, item }">
            <v-tooltip location="top">
              <template v-slot:activator="{ props: tooltipProps }">
                <div v-bind="props" class="dropdown-item" @click="props.onClick">
                  <span v-bind="tooltipProps" class="text-truncate">{{ item.title }}</span>
                </div>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </template>
        </v-select>
      </v-col>
      
      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
        {{ snackbar.message }}
      </v-snackbar>
    </v-form>
    
    <!-- Dialogs -->
    <v-dialog transition="dialog-top-transition" v-model="confirmDeleteDialog" width="417">
      <div class="cross-btn-div" @click="closeDeleteConfirmation">
        <v-img :src="cross" alt="close"></v-img>
      </div>
      <v-alert title="Delete Plot" :text=confirmDeleteText>
        <div class="alert-btns-div">
          <v-btn class="cancel-btn" flat @click="closeDeleteConfirmation">Cancel</v-btn>
          <v-btn class="delete-btn" flat @click="deleteChart" :loading="deleteLoading">
            <v-img :src="delete_icon" alt="delete-icon" width="16" height="15" class="mr-2"></v-img>
            Delete Plot</v-btn>
        </div>
      </v-alert>
    </v-dialog>
    <v-dialog transition="dialog-top-transition" v-model="confirmUpdateDialog" width="417">
      <div class="cross-btn-div" @click="closeUpdateConfirmation">
        <v-img :src="cross" alt="close"></v-img>
      </div>
      <v-alert title="Update Plot" :text=confirmUpdateText>
        <div class="alert-btns-div">
          <v-btn class="cancel-btn" flat @click="closeUpdateConfirmation">Cancel</v-btn>
          <v-btn
            v-if="selectedSavedChartName != null && (accessLevel == 'private' || (accessLevel == 'public' && isAdmin))"
            flat :disabled="!isUpdateEnabled" :loading="updateLoading" class="save-btn text-none update-btn"
            @click="updateChart">
            <div class="save-btn-img ml-2">
              <v-img src="../../../assets/Images/save btn.png" alt="update"></v-img>
            </div>
            <span>Update</span>
          </v-btn>
        </div>
      </v-alert>
    </v-dialog>
    <StudioModal ref="childComponent" @open-dialog="openDialog" />
    <Filters ref="filters" v-if="isFluidsDataStudio" @drawerStateChanged="handleRightDrawerStateChange"
      :callDefaultFilter="callDefaultFilter" :selectedType="selectedTableTypeName" :filterFromChart="filterFromChart"
      @filter-data="getTableDataAgainstFilter" @reset-saved-filter="handleResetSavedFilter"
      @reset-call-default-filter="resetCallDefaultFilter" @update-chart="callUpdateChartMethod"
      @drawerValue="toggleInputs" />
  </div>
</template>

<script>
import api from "../../../axiosInterceptor";
// import TabularLoaders from "../Loaders/TabularLoaders.vue";
import Filters from "../Common/Filters.vue";
import screenWidthMixin from "../../../assets/JS/screenWidthMixin";
import StudioModal from "./StudioModal.vue";
import { mapGetters } from "vuex";
import { eventBus } from "../../../eventBus.js";
export default {
  name: "StudioDataLeft",
  components: { Filters, StudioModal },
  data() {
    return {
      cross: require("../../../assets/Images/Buttons/cross.png"),
      delete_icon: require("../../../assets/Images/delete btn.png"),
      addDashboard: require("../../../assets/Svg/add-dash.svg"),
      confirmDeleteDialog: false,
      confirmUpdateDialog: false,
      searchQuery: "",
      chartTypes: [],
      tableTypes: [],
      internalChartTitle: "",
      chartType: "", // Remove the prop reference, initialize as empty string
      xAxisItems: [],
      yAxisItems: [],
      zAxisItems: [],
      colorGroupItems: [],
      selectedXAxisKey: [],
      selectedYAxisKey: [],
      selectedZAxisKey: [],
      selectedColorGroupKey: null,
      xAxisData: [],
      yAxisData: [],
      zAxisData: [],
      colorGroupData: [],
      showXBinsInput: false,
      showXAxis: true,
      showYAxis: true,
      showZAxis: false,
      showColorGroup: false,
      xBins: 20,
      showYBinsInput: false,
      yBins: 20,
      chartTypesNames: [],
      tableTypesNames: [],
      selectedChartTypeName: null,
      selectedTableTypeName: null,
      selectedSavedChartName: null,
      savedCharts: [],
      savedChartsNames: [],
      tableData: [],
      showLoaders: false,
      deleteError: null,
      showTooltip: false,
      snackbar: {
        visible: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
      createLoading: false,
      updateLoading: false,
      deleteLoading: false,
      loadingSavedCharts: false,
      loadingXAxisData: false,
      loadingYAxisData: false,
      loadingZAxisData: false,
      loadingTableType: false,
      loadingChartType: false,
      createNewChart: false,
      chartSaved: false,
      accessLevel: "private",
      isPublic: false,
      resetSavedFilter: false,
      callDefaultFilter: false,
      icon: require("../../../assets/Images//arrow-down.png"),
      icon2: require("../../../assets/Images/arrow-up.png"),
      showInputs: true,
      savedFilterData: [],
      savedType: "",
      colorGroupChanged: false,
      xAxisChanged: false,
      yAxisChanged: false,
      zAxisChanged: false,
      axisSelected: false,
      sampleIdPresent: false,
      filterFromChart: [],
      chartSearchQuery: "",
      tableTypeSearchQuery: "",
      chartTypeSearchQuery: "",
      filteredChartsNames: [],
      filteredTableTypesNames: [],
      filteredChartTypesNames: [],
      onlyApiCall: false,
      filterReset: false,
      filteredXAxisItems: [],
      filteredYAxisItems: [],
      filteredZAxisItems: [],
      filteredColorGroupItems: [],
      xAxisSearchQuery: "",
      yAxisSearchQuery: "",
      zAxisSearchQuery: "",
      colorGroupSearchQuery: "",
      xAxisAbortController: null,
      yAxisAbortController: null,
      zAxisAbortController: null,
      colorGroupAbortController: null,
      xAxisScale: "linear",
      yAxisScale: "linear",
      isXLog: false,
      isYLog: false,
      selectedChartId: null,
      confirmDeleteText: null,
      isUpdateEnabled: false,
      // timeoutMessage: "",
      // tableDataType: "",
      xAxisDisplayName: "",
      yAxisDisplayNames: [],
      zAxisDisplayName: "",
      xAxisCaption: [],
      yAxisCaption: [],
      // Add unique identifier for each API call to prevent data mixing
      currentApiCallId: null,
      // Data chunking properties for handling large datasets
      dataChunkSize: 1000, // Process 1000 rows at a time
      isProcessingLargeData: false,
      processedDataCount: 0,
      colorGroupSelectionTimeout: null,
      // AbortController instances for request cancellation
      tableTypeAbortController: null,
      chartTypeAbortController: null,
      dataFetchAbortController: null,
      chartUsageAbortController: null,
      chartDataAbortController: null,
      // Flag to track user selections and prevent data restoration from overriding them
      isUserSelecting: false,
    };
  },
  props: {
    selectedChartType: {
      type: String,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    editPlotData: {
      type: Object,
      default: null,
    },
    chartTitle: {
      type: String,
      default: '',
    },
  },
  mixins: [screenWidthMixin],
  computed: {
    ...mapGetters("tenantId", ["getUser"]),
    isAdmin() {
      return this.getUser && (this.getUser.role === "Administrator" || this.getUser.role === "SuperAdmin");
    },
    userFullName() {
      if (this.getUser && this.getUser.firstName && this.getUser.lastName) {
        return `${this.getUser.firstName} ${this.getUser.lastName}`;
      }
      return this.getUser?.username || '';
    },
    isFluidsDataStudio() {
      const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
      return pathSegments.length > 1 && pathSegments[1].toLowerCase() === 'fluidsdata-studio';
    },

    isDashboard() {
      const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
      return (
        pathSegments.length > 2 &&
        (pathSegments[1].toLowerCase() === 'dashboards' && pathSegments[2].toLowerCase() === 'create') ||
        (pathSegments[1].toLowerCase() === 'dashboards' && pathSegments[2].toLowerCase() === 'edit')
      );
    },
    updateXBins() {
      this.$emit("update-x-bins", Number(this.xBins));
      let savedChartData = JSON.parse(localStorage.getItem("savedChartData")) || JSON.parse(localStorage.getItem("newsavedChartData"));
      if (savedChartData?.NumXBins) {
        savedChartData.NumXBins = Number(this.xBins);
        if (localStorage.getItem("savedChartData")) {
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        } else {
          localStorage.setItem("newsavedChartData", JSON.stringify(savedChartData));
        }
      }
      this.saveChartData();
    },
    updateYBins() {
      this.$emit("update-y-bins", Number(this.yBins));
      let savedChartData = JSON.parse(localStorage.getItem("savedChartData")) || JSON.parse(localStorage.getItem("newsavedChartData"));
      if (savedChartData?.NumYBins) {
        savedChartData.NumYBins = Number(this.yBins);
        if (localStorage.getItem("savedChartData")) {
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        } else {
          localStorage.setItem("newsavedChartData", JSON.stringify(savedChartData));
        }
      }
      this.saveChartData();
    },
    xBinsAsNumber() {
      return Number(this.xBins);
    },
    yBinsAsNumber() {
      return Number(this.yBins);
    },
    isFormValid() {
      // Check basic required fields
      const isBasicFieldsFilled =
        this.selectedChartTypeName &&
        this.internalChartTitle &&
        this.selectedTableTypeName;
      
      // Check X-axis if required
      const isXAxisFilled = !this.showXAxis || (this.selectedXAxisKey && this.selectedXAxisKey.length > 0);
      
      // Check Y-axis if required
      const isYAxisFilled =
        !this.showYAxis ||
        (Array.isArray(this.selectedYAxisKey) &&
          this.selectedYAxisKey.length > 0);
      
      // Check Z-axis if required
      const isZAxisFilled = !this.showZAxis || (this.selectedZAxisKey && this.selectedZAxisKey.length > 0);
      

      
      return (
        isBasicFieldsFilled && isXAxisFilled && isYAxisFilled && isZAxisFilled
      );
    },
    shouldRenderChartList() {
      return this.shouldRenderComponent([
        "FluidsDataStudioTwo"
      ]);
    },
  },
  watch: {
    chartTitle: {
      handler(newVal) {
        this.internalChartTitle = newVal || '';
      },
      immediate: true,
    },
    selectedChartTypeName: "updateIsUpdateEnabled",
    selectedTableTypeName: "updateIsUpdateEnabled",
    selectedXAxisKey: "updateIsUpdateEnabled",
    selectedZAxisKey: "updateIsUpdateEnabled",
    xBins: "updateIsUpdateEnabled",
    yBins: "updateIsUpdateEnabled",
    xAxisScale: "updateIsUpdateEnabled",
    yAxisScale: "updateIsUpdateEnabled",
    accessLevel: "updateIsUpdateEnabled",
    selectedColorGroupKey(newValue) {
      this.updateIsUpdateEnabled();
      if (newValue === "") {
        this.selectedColorGroupKey = null;
      }
    },
    rightContentStyle(newStyle) {
      this.$emit("update-right-content-style", newStyle);
    },
    editPlotData: {
      handler(newVal) {
        if (newVal && this.isEditing) {
          this.populateEditData(newVal);
        }
      },
      immediate: true,
      deep: true
    },
    isEditing(newVal) {
      if (newVal && this.editPlotData) {
        this.populateEditData(this.editPlotData);
      }
    },
    selectedChartType: {
      handler(newVal) {
        // Sync the prop with local data property
        this.chartType = newVal || '';
      },
      immediate: true
    },
    isFormValid: {
      handler(newVal) {
        // Emit form validation status to parent
        this.$emit('form-validation', newVal);
      },
      immediate: true
    },
    selectedYAxisKey: {
      handler(newVal, oldVal) {
        
        // Filter out legend properties from Y-axis selections
        if (newVal && Array.isArray(newVal) && newVal.length > 0) {
          const filteredVal = this.filterLegendFromYAxis(newVal);
          if (filteredVal.length !== newVal.length) {
              this.selectedYAxisKey = filteredVal;
            return; // Don't call updateIsUpdateEnabled again
          }
        }
        
        this.updateIsUpdateEnabled();
      },
      deep: true
    },
  },
  methods: {
    // Request cancellation methods
    cancelTableTypeRequest() {
      if (this.tableTypeAbortController) {
        this.tableTypeAbortController.abort();
        this.tableTypeAbortController = null;
      }
    },
    
    cancelChartTypeRequest() {
      if (this.chartTypeAbortController) {
        this.chartTypeAbortController.abort();
        this.chartTypeAbortController = null;
      }
    },
    
    cancelDataFetchRequest() {
      if (this.dataFetchAbortController) {
        // Don't clear Y-axis data when cancelling - preserve user selections
        this.dataFetchAbortController.abort();
        this.dataFetchAbortController = null;
      }
    },
    
    cancelChartUsageRequest() {
      if (this.chartUsageAbortController) {
        this.chartUsageAbortController.abort();
        this.chartUsageAbortController = null;
      }
    },
    
    cancelChartDataRequest() {
      if (this.chartDataAbortController) {
        this.chartDataAbortController.abort();
        this.chartDataAbortController = null;
      }
    },
    
    // Cancel all pending requests
    cancelAllRequests() {
      this.cancelTableTypeRequest();
      this.cancelChartTypeRequest();
      this.cancelDataFetchRequest();
      this.cancelChartUsageRequest();
      this.cancelChartDataRequest();
    },

    // Preserve Y-axis data during API calls
    preserveYAxisData() {
      // Filter out legend properties before preserving
      const filteredYAxisKeys = this.filterLegendFromYAxis(this.selectedYAxisKey);
      
      
      return {
        selectedYAxisKey: [...(filteredYAxisKeys || [])],
        yAxisData: this.yAxisData ? [...this.yAxisData] : []
      };
    },

    // Restore Y-axis data after API calls
    restoreYAxisData(preservedData) {
      if (preservedData && preservedData.selectedYAxisKey) {
        this.selectedYAxisKey = preservedData.selectedYAxisKey;
        if (preservedData.yAxisData && preservedData.yAxisData.length > 0) {
          this.yAxisData = preservedData.yAxisData;
        }
      }
    },

    // Reset user selection flag after API calls complete
    resetUserSelectionFlag() {
      this.isUserSelecting = false;
    },

    // Filter out legend properties from Y-axis selections
    filterLegendFromYAxis(yAxisKeys) {
      if (!yAxisKeys || !Array.isArray(yAxisKeys)) {
        return yAxisKeys;
      }
      
      const filteredKeys = yAxisKeys.filter(key => {
        // Check if this key is a legend property
        const isLegendProperty = this.colorGroupItems.some(item => item.name === key);
        if (isLegendProperty) {
        }
        return !isLegendProperty;
      });
      
      
      return filteredKeys;
    },

    handleRightDrawerStateChange(isOpen) {
      // Use the mixin's method to handle the drawer state
      if (this.screenWidth >= 768) {
        this.rightDrawerOpen = isOpen;
        localStorage.setItem('sidebarState', isOpen ? 'true' : 'false');
        this.$forceUpdate();
      }
      
      // Emit the updated rightContentStyle to parent component
      this.$emit("update-right-content-style", this.rightContentStyle);
      
      // Emit resizeChart event when filter drawer state changes
      this.$nextTick(() => {
        eventBus.emit("resizeChart");
        eventBus.emit("filterDrawerToggled");
      });
    },
    handleXScaleToggleChange() {
      this.xAxisScale = this.isXLog ? "log" : "linear";
      this.$emit("x-axis-scale", this.xAxisScale);
    },
    handleYScaleToggleChange() {
      this.yAxisScale = this.isYLog ? "log" : "linear";
      this.$emit("y-axis-scale", this.yAxisScale);
    },
    resetFilterChartList() {
      this.chartSearchQuery = "";
      this.filteredChartsNames = this.savedChartsNames;
    },
    resetTableTypeList() {
      this.tableTypeSearchQuery = "";
      this.filteredTableTypesNames = this.tableTypesNames;
    },
    resetChartTypeList() {
      this.chartTypeSearchQuery = "";
      this.filteredChartTypesNames = this.chartTypesNames;
    },
    resetXAxisList() {
      this.xAxisSearchQuery = "";
      this.filteredXAxisItems = this.xAxisItems;
    },
    resetYAxisList() {
      this.yAxisSearchQuery = "";
      this.filteredYAxisItems = this.yAxisItems;
    },
    resetZAxisList() {
      this.zAxisSearchQuery = "";
      this.filteredZAxisItems = this.zAxisItems;
    },
    resetColorGroupList() {
      this.colorGroupSearchQuery = "";
      this.filteredColorGroupItems = this.colorGroupItems;
    },
    // Filter the chart list based on the search query
    filterChartList() {
      const query = this.chartSearchQuery.toLowerCase();
      this.filteredChartsNames = this.savedChartsNames.filter((chart) =>
        chart.toLowerCase().includes(query)
      );
    },
    // Filter the table list based on the search query
    filterTableTypeList() {
      const query = this.tableTypeSearchQuery.toLowerCase();
      this.filteredTableTypesNames = this.tableTypesNames.filter((chart) =>
        chart.toLowerCase().includes(query)
      );
    },
    // Filter the chart type list based on the search query
    filterChartTypeList() {
      const query = this.chartTypeSearchQuery.toLowerCase();
      this.filteredChartTypesNames = this.chartTypesNames.filter((chart) =>
        chart.toLowerCase().includes(query)
      );
    },
    // Filter the x-axis list based on the search query
    filterXAxisList() {
      const query = this.xAxisSearchQuery.toLowerCase();
      this.filteredXAxisItems = this.xAxisItems.filter((chart) =>
        chart.displayName.toLowerCase().includes(query)
      );
    },
    // Filter the y-axis list based on the search query
    filterYAxisList() {
      const query = this.yAxisSearchQuery.toLowerCase();
      this.filteredYAxisItems = this.yAxisItems.filter((chart) =>
        chart.displayName.toLowerCase().includes(query)
      );
    },
    // Filter the z-axis list based on the search query
    filterZAxisList() {
      const query = this.zAxisSearchQuery.toLowerCase();
      this.filteredZAxisItems = this.zAxisItems.filter((chart) =>
        chart.displayName.toLowerCase().includes(query)
      );
    },
    // Filter the color group list based on the search query
    filterColorGroupList() {
      const query = this.colorGroupSearchQuery.toLowerCase();
      this.filteredColorGroupItems = this.colorGroupItems.filter((chart) =>
        chart.displayName.toLowerCase().includes(query)
      );
    },
    updateIsUpdateEnabled() {
      this.isUpdateEnabled = this.checkIfUpdateEnabled();
    },
    handleUpdateClick() {
      this.isUpdateEnabled = this.checkIfUpdateEnabled(); // Recalculate on button click
      if (this.isUpdateEnabled) {
        this.showUpdateConfirmation(this.selectedChartId);
      }
    },
    checkIfUpdateEnabled() {
      let initialChartData = JSON.parse(localStorage.getItem("initialChartData"));

      if (!initialChartData) return false;

      if (!this.selectedChartTypeName || !this.selectedTableTypeName) {
        return false;
      }

      const hasBasicFieldsChanged =
        this.selectedChartTypeName !== initialChartData.ChartType ||
        this.selectedTableTypeName !== initialChartData.TableType;

      const hasXAxisChanged =
        this.showXAxis && this.selectedXAxisKey !== initialChartData.XAxisColumn;

      const hasYAxisChanged =
        this.showYAxis &&
        Array.isArray(this.selectedYAxisKey) &&
        this.selectedYAxisKey.join(",") !== initialChartData.YAxisColumn;

      const hasZAxisChanged =
        this.showZAxis && this.selectedZAxisKey !== initialChartData.ZAxisColumn;

      const hasColorGroupChanged =
        (this.selectedColorGroupKey || "") !== (initialChartData.GroupColumn || "");

      const hasXBinsChanged =
        (this.xBins || null) !== (initialChartData.NumXBins || null);

      const hasYBinsChanged =
        (this.yBins || null) !== (initialChartData.NumYBins || null);

      const hasXScaleChanged =
        (this.xAxisScale || "") !== (initialChartData.XAxisScale || "");

      const hasYScaleChanged =
        (this.yAxisScale || "") !== (initialChartData.YAxisScale || "");

      const hasAccessLevelChanged =
        this.accessLevel !== initialChartData.AccessLevel;

      const initialAssets = initialChartData.Filter?.asset || [];
      const savedAssets = this.savedFilterData.asset ? Array.from(this.savedFilterData.asset) : [];

      const hasAssetFilterChanged =
        initialAssets.length !== savedAssets.length ||
        !initialAssets.every((item) => savedAssets.includes(item));

      const initialFields = initialChartData.Filter?.field || [];
      const savedFields = this.savedFilterData.field ? Array.from(this.savedFilterData.field) : [];

      const hasFieldFilterChanged =
        initialFields.length !== savedFields.length ||
        !initialFields.every((item) => savedFields.includes(item));

      const initialSampleKinds = initialChartData.Filter?.fluidType || [];
      const savedSampleKinds = this.savedFilterData.fluidType ? Array.from(this.savedFilterData.fluidType) : [];

      const hasSampleKindFilterChanged =
        initialSampleKinds.length !== savedSampleKinds.length ||
        !initialSampleKinds.every((item) => savedSampleKinds.includes(item));

      const initialWells = initialChartData.Filter?.well || [];
      const savedWells = this.savedFilterData.well ? Array.from(this.savedFilterData.well) : [];

      const hasWellFilterChanged =
        initialWells.length !== savedWells.length ||
        !initialWells.every((item) => savedWells.includes(item));

      const initialReservoirs = initialChartData.Filter?.reservoir || [];
      const savedReservoirs = this.savedFilterData.reservoir ? Array.from(this.savedFilterData.reservoir) : [];

      const hasReservoirFilterChanged =
        initialReservoirs.length !== savedReservoirs.length ||
        !initialReservoirs.every((item) => savedReservoirs.includes(item));

      return (
        hasBasicFieldsChanged ||
        hasXAxisChanged ||
        hasYAxisChanged ||
        hasZAxisChanged ||
        hasColorGroupChanged ||
        hasXBinsChanged ||
        hasYBinsChanged ||
        hasXScaleChanged ||
        hasYScaleChanged ||
        hasAccessLevelChanged ||
        hasAssetFilterChanged ||
        hasFieldFilterChanged ||
        hasSampleKindFilterChanged ||
        hasWellFilterChanged ||
        hasReservoirFilterChanged
      );
    },
    async showDeleteConfirmation(chartID) {
      try {
        // Make an API call to check if the chart is used in any dashboards
        const response = await api.get(`/public/api/charts/${chartID}/usage`);
        const data = response.data.data;
        if (Array.isArray(data) && data.length > 0) {
          // If used in multiple dashboards, ask for confirmation
          this.confirmDeleteText = `This plot is used in ${data.length} dashboards. After deletion, it will be removed from all dashboards. Do you still want to delete this plot?`;
          this.confirmDeleteDialog = true;
        } else {
          this.confirmDeleteText = "Are you sure you want to delete plot?";
          this.confirmDeleteDialog = true;
          //this.deleteChart(); // Proceed to delete if not used in multiple dashboards
        }
      } catch (error) {
      }
    },
    closeDeleteConfirmation() {
      this.confirmDeleteDialog = false;
    },
    async showUpdateConfirmation(chartID) {
      try {
        const response = await api.get(`/public/api/charts/${chartID}/usage`);
        const data = response.data?.data ?? [];

        if (Array.isArray(data) && data.length > 0) {
          // If used in multiple dashboards, ask for confirmation
          this.confirmUpdateText = `This plot is used in ${data.length} dashboards. Do you still want to update this plot? If you update this plot, this change will be reflected in all dashboards as well.`;
        } else {
          // No dashboards using this plot
          this.confirmUpdateText = "Are you sure you want to update plot?";
        }

        this.confirmUpdateDialog = true;

      } catch (error) {
      }
    },

    closeUpdateConfirmation() {
      this.confirmUpdateDialog = false;
    },
    openDialog() {
      if (this.$refs.childComponent) {
        this.$refs.childComponent.openDialog();
      } else {
      }
    },
    //   retryGetTableData() {
    //   let selectedType = this.tableDataType;
    //   this.getTableData(selectedType);
    // },
    toggleInputs(drawer) {
      this.$emit("handle-chart-height", drawer);
      
      // Emit resizeChart event when filter drawer state changes
      this.$nextTick(() => {
        eventBus.emit("resizeChart");
        eventBus.emit("filterDrawerToggled");
      });
    },
    handleDrawerStateChange(isOpen) {
      if (this.screenWidth >= 768) {
        this.drawerOpen = isOpen;
        
        // Emit resizeChart event when drawer state changes
        this.$nextTick(() => {
          eventBus.emit("resizeChart");
          eventBus.emit("filterDrawerToggled");
        });
      }
    },
    resetCallDefaultFilter() {
      this.callDefaultFilter = false;
    },
    callUpdateChartMethod() {
      this.updateChart()
    },
    handleResetSavedFilter() {
      this.filterReset = true;
      const savedChartData = localStorage.getItem("savedChartData") || localStorage.getItem("newsavedChartData");
      if (savedChartData) {
        const chartData = JSON.parse(savedChartData);
        if (chartData) {
          this.savedChartChangeLoad(chartData);
        }
      }
    },
    shouldRenderComponent(allowedRoutes) {
      return allowedRoutes.includes(this.$route.name);
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    goToCreateChart() {
      this.resetChartData();
    },
    async tableTypeChange(selectedType) {
      
      // Cancel any previous table type request
      this.cancelTableTypeRequest();
      
      // Create new AbortController for this request
      this.tableTypeAbortController = new AbortController();
      
      this.loadingXAxisData = true;
      this.loadingYAxisData = true;
      this.loadingZAxisData = true;
      this.selectedTableTypeName = selectedType;
      const tableTypeString = JSON.stringify(selectedType);
      localStorage.setItem("selectedTableType", this.selectedTableTypeName);
      
      try {
        const response = await api.get(
          "public/api/tables/type?table=" +
          encodeURIComponent(tableTypeString),
          { signal: this.tableTypeAbortController.signal }
        );
        
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.loadingXAxisData = false;
          this.loadingYAxisData = false;
          this.loadingZAxisData = false;
          
          const columns = response.data.data.tableTypes.columns.filter(column => column.displayName);
          columns.sort((a, b) => (a.columnSortOrder || 999) - (b.columnSortOrder || 999));
          
          this.xAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredXAxisItems = this.xAxisItems;
          
          this.yAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredYAxisItems = this.yAxisItems;
          
          this.zAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredZAxisItems = this.zAxisItems;
          
          
          this.colorGroupItems = columns.filter(column => column.legend)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.legendSortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredColorGroupItems = this.colorGroupItems;
          
          
          // Reset axis selections instead of auto-selecting
          this.resetAxisSelections();
          this.saveChartData();
          
          let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
          if (savedChartData) {
            savedChartData.TableType = this.selectedTableTypeName;
            localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
          }
        } else if (response && response.data && response.data.message) {
          this.showSnackbar(response.data.message, "error");
        } else {
          this.showSnackbar("Error fetching table types.", "error");
        }
      } catch (error) {
        // Check if the request was cancelled
        if (error.name === 'AbortError') {
          return;
        }
        
        this.loadingXAxisData = false;
        this.loadingYAxisData = false;
        this.loadingZAxisData = false;
      } finally {
        // Clean up the AbortController
        this.tableTypeAbortController = null;
      }
    },
    async tableTypeChangeAgainstFilter(selectedType) {
      // Cancel any previous table type request
      this.cancelTableTypeRequest();
      
      // Create new AbortController for this request
      this.tableTypeAbortController = new AbortController();
      
      this.loadingXAxisData = true;
      this.loadingYAxisData = true;
      this.loadingZAxisData = true;
      this.resetAxisSelections();
      this.selectedTableTypeName = selectedType;
      const tableTypeString = JSON.stringify(selectedType);
      localStorage.setItem("selectedTableType", this.selectedTableTypeName)
      try {
        const response = await api.get(
          "public/api/tables/type?table=" +
          encodeURIComponent(tableTypeString),
          { signal: this.tableTypeAbortController.signal }
        );
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.loadingXAxisData = false;
          this.loadingYAxisData = false;
          this.loadingZAxisData = false;
          const columns = response.data.data.tableTypes.columns.filter(column => column.displayName);
          columns.sort((a, b) => (a.columnSortOrder || 999) - (b.columnSortOrder || 999));
          this.xAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 })).sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredXAxisItems = this.xAxisItems
          this.yAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 })).sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredYAxisItems = this.yAxisItems
          this.zAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 })).sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredZAxisItems = this.zAxisItems
          this.colorGroupItems = columns.filter(column => column.legend)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.legendSortOrder || 999 })).sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredColorGroupItems = this.colorGroupItems
        }
        else if (response && response.data && response.data.message) {
          this.showSnackbar(response.data.message, "error");
        }
        else {
          this.showSnackbar("error fetching table types.", "error");
        }
      } catch (error) {
        // Check if the request was cancelled
        if (error.name === 'AbortError') {
          return;
        }
        
      } finally {
        // Clean up the AbortController
        this.tableTypeAbortController = null;
      }
    },
    hasValidMinMax(obj) {
      // Check if the object has valid min/max values (not null, not empty string, not undefined)
      if (!obj || typeof obj !== 'object') return false;
      const hasMin = obj.min !== null && obj.min !== undefined && obj.min !== '';
      const hasMax = obj.max !== null && obj.max !== undefined && obj.max !== '';
      return hasMin || hasMax;
    },
    async getTableData(signal) {
      
      // Preserve Y-axis data before making API call
      const preservedYAxisData = this.preserveYAxisData();
      
      // Cancel any previous data fetch request
      this.cancelDataFetchRequest();
      
      // Create new AbortController for this request
      this.dataFetchAbortController = new AbortController();
      
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      this.$emit("sample-error", "");
      
      // Retrieve the selected table type from localStorage
      var selectedType = localStorage.getItem("selectedTableType");
      
      // Initialize an array for selected columns
      let selectedColumns = [];
      
      // Safely add each key to selectedColumns if it exists and is not empty
      if (typeof this.selectedXAxisKey === "string" && this.selectedXAxisKey.trim() !== "") {
        selectedColumns.push(this.selectedXAxisKey.trim());
      }
      if (Array.isArray(this.selectedYAxisKey)) {
        // If selectedYAxisKey is an array, add its non-empty trimmed values
        selectedColumns.push(
          ...this.selectedYAxisKey
            .filter((key) => typeof key === "string" && key.trim() !== "")
            .map((key) => key.trim())
        );
      } else if (typeof this.selectedYAxisKey === "string" && this.selectedYAxisKey.trim() !== "") {
        selectedColumns.push(this.selectedYAxisKey.trim());
      }
      if (typeof this.selectedZAxisKey === "string" && this.selectedZAxisKey.trim() !== "") {
        selectedColumns.push(this.selectedZAxisKey.trim());
      }
      if (typeof this.selectedColorGroupKey === "string" && this.selectedColorGroupKey.trim() !== "") {
        selectedColumns.push(this.selectedColorGroupKey.trim());
      }
      
      // Filter out any invalid entries as an extra safety measure
      selectedColumns = selectedColumns.filter((column) => column);
      
      // If no columns are selected, exit early
      if (selectedColumns.length === 0) {
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        return;
      }
      
      try {
        // Build query parameters object starting with selectColumns
        const queryParams = {
          selectColumns: JSON.stringify(selectedColumns)
        };
        
        // Check for pending filter data and include it in the API call
        const pendingFilterData = localStorage.getItem("pendingFilterData");
        const filterActive = localStorage.getItem("filterActive");
        
        
        if (pendingFilterData && filterActive === "true") {
          try {
            const pendingFilter = JSON.parse(pendingFilterData);
            
            // Add filter parameters from pending filter data - only include non-empty values
            if (pendingFilter.asset && pendingFilter.asset.length) {
              queryParams.asset = JSON.stringify(pendingFilter.asset);
            }
            if (pendingFilter.field && pendingFilter.field.length) {
              queryParams.field = JSON.stringify(pendingFilter.field);
            }
            if (pendingFilter.well && pendingFilter.well.length) {
              queryParams.well = JSON.stringify(pendingFilter.well);
            }
            if (pendingFilter.reservoir && pendingFilter.reservoir.length) {
              queryParams.reservoir = JSON.stringify(pendingFilter.reservoir);
            }
            if (pendingFilter.fluidType && pendingFilter.fluidType.length) {
              queryParams.fluidType = JSON.stringify(pendingFilter.fluidType);
            }
            if (pendingFilter.sampleType && pendingFilter.sampleType.length) {
              queryParams.sampleType = JSON.stringify(pendingFilter.sampleType);
            }
            if (pendingFilter.fluidClassification && pendingFilter.fluidClassification.length) {
              queryParams.fluidClassification = JSON.stringify(pendingFilter.fluidClassification);
            }
            if (pendingFilter.fluidSampleID && pendingFilter.fluidSampleID.length) {
              queryParams.fluidSampleID = JSON.stringify(pendingFilter.fluidSampleID);
            }
            if (pendingFilter.fluidSampleContainerID && pendingFilter.fluidSampleContainerID.length) {
              queryParams.fluidSampleContainerID = JSON.stringify(pendingFilter.fluidSampleContainerID);
            }
            if (pendingFilter.source && pendingFilter.source.trim()) {
              queryParams.source = `"${pendingFilter.source}"`;
            }
            // Only include date/depth/pressure/temperature if they have valid min/max values
            if (pendingFilter.sampleDate && this.hasValidMinMax(pendingFilter.sampleDate)) {
              queryParams.sampleDate = JSON.stringify(pendingFilter.sampleDate);
            }
            if (pendingFilter.depth && this.hasValidMinMax(pendingFilter.depth)) {
              queryParams.depth = JSON.stringify(pendingFilter.depth);
            }
            if (pendingFilter.formationPressure && this.hasValidMinMax(pendingFilter.formationPressure)) {
              queryParams.formationPressure = JSON.stringify(pendingFilter.formationPressure);
            }
            if (pendingFilter.formationTemperature && this.hasValidMinMax(pendingFilter.formationTemperature)) {
              queryParams.formationTemperature = JSON.stringify(pendingFilter.formationTemperature);
            }
            
          } catch (error) {
            console.error("Error parsing pending filter data in getTableData:", error);
          }
        }
        
        // Build query string from all parameters
        const queryString = Object.entries(queryParams)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");


        const response = await api.get(
          `public/api/tables/data/${selectedType}?${queryString}`,
          { signal: this.dataFetchAbortController.signal }
        );
        
        // Check if the API response is successful
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          if (response.data.error) {
            this.$emit("sample-error", response.data.error);
            return;
          }
          
          this.tableData = response.data.data.samples.rows;
          
          // Emit table data for CSV export
          this.$emit("table-data", this.tableData);

          // Enhanced debugging of the received data structure
          if (this.tableData && this.tableData.length > 0) {
            const firstRow = this.tableData[0];
            selectedColumns.forEach(col => {
              const exists = col in firstRow;
              const value = firstRow[col];
              const valueType = typeof value;
            });
            
            // Check for potential column name variations
            const allKeys = Object.keys(firstRow);
            selectedColumns.forEach(col => {
              const variations = allKeys.filter(key => 
                key.toLowerCase().includes(col.toLowerCase()) || 
                col.toLowerCase().includes(key.toLowerCase())
              );
            });
          }
          
          if (this.tableData === null) {
            this.$emit("sample-error", "Data is not available to plot chart.");
            return;
          }
          
          await this.extractAllAxisData();
          
          // Reset user selection flag after data processing is complete
          this.resetUserSelectionFlag();
        } else if (response && response.data && response.data.message) {
          this.$emit("sample-error", response.data.message);
        } else if (response && response.data && response.data.error) {
          this.$emit("sample-error", response.data.error);
        } else {
          this.$emit("sample-error", "Error fetching table data.");
        }
      } catch (error) {
        // Check if the request was cancelled
        if (error.name === 'AbortError') {
          // Restore Y-axis data when request is cancelled
          this.restoreYAxisData(preservedYAxisData);
          return;
        }
        
        if (error.response && error.response.data) {
          let sampleError = error.response.data.error;
          this.$emit("sample-error", sampleError);
        } else {
          this.$emit("sample-error", "An error occurred while fetching data.");
        }
      } finally {
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        // Clean up the AbortController
        this.dataFetchAbortController = null;
      }
    },
    async getTableDataAgainstFilter({ filterData, type, filterCalled }, signal) {
      if (filterCalled == true) {
        this.onlyApiCall = false;
      }

      // Preserve Y-axis data before making API call
      const preservedYAxisData = this.preserveYAxisData();

      // Cancel any previous data fetch request
      this.cancelDataFetchRequest();
      
      // Create new AbortController for this request
      this.dataFetchAbortController = new AbortController();

      var selectedType = localStorage.getItem("selectedTableType")
      this.savedFilterData = filterData
      this.savedType = selectedType
      this.$emit("sample-error", "");
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      try {
        const queryParams = {};
        const minMaxFormatter = ({ min = "", max = "" }) => JSON.stringify({ min, max });
        // Add filters to queryParams only if they have values
        if (filterData.asset && filterData.asset.length) queryParams.asset = JSON.stringify(filterData.asset);
        if (filterData.field && filterData.field.length) queryParams.field = JSON.stringify(filterData.field);
        if (filterData.well && filterData.well.length) queryParams.well = JSON.stringify(filterData.well);
        if (filterData.reservoir && filterData.reservoir.length) queryParams.reservoir = JSON.stringify(filterData.reservoir);
        if (filterData.fluidType && filterData.fluidType.length) queryParams.fluidType = JSON.stringify(filterData.fluidType);
        if (filterData.sampleType && filterData.sampleType.length) queryParams.sampleType = JSON.stringify(filterData.sampleType);
        if (filterData.fluidClassification && filterData.fluidClassification.length) queryParams.fluidClassification = JSON.stringify(filterData.fluidClassification);
        if (filterData.fluidSampleID && filterData.fluidSampleID.length) queryParams.fluidSampleID = JSON.stringify(filterData.fluidSampleID);
        if (filterData.fluidSampleContainerID && filterData.fluidSampleContainerID.length) queryParams.fluidSampleContainerID = JSON.stringify(filterData.fluidSampleContainerID);
        if (filterData.source && filterData.source.trim()) queryParams.source = `"${filterData.source}"`;
        if (filterData.sampleDate && this.hasValidMinMax(filterData.sampleDate)) queryParams.sampleDate = minMaxFormatter(filterData.sampleDate);
        if (filterData.depth && this.hasValidMinMax(filterData.depth)) queryParams.depth = minMaxFormatter(filterData.depth);
        if (filterData.formationPressure && this.hasValidMinMax(filterData.formationPressure)) queryParams.formationPressure = minMaxFormatter(filterData.formationPressure);
        if (filterData.formationTemperature && this.hasValidMinMax(filterData.formationTemperature)) queryParams.formationTemperature = minMaxFormatter(filterData.formationTemperature);
        // Add selectColumns logic here
        let selectedColumns = [];
        // Add selected X/Y/Z & color group keys
        if (typeof this.selectedXAxisKey === "string" && this.selectedXAxisKey.trim() !== "") {
          selectedColumns.push(this.selectedXAxisKey.trim());
        }
        if (Array.isArray(this.selectedYAxisKey)) {
          selectedColumns.push(
            ...this.selectedYAxisKey
              .filter((key) => typeof key === "string" && key.trim() !== "")
              .map((key) => key.trim())
          );
        } else if (typeof this.selectedYAxisKey === "string" && this.selectedYAxisKey.trim() !== "") {
          selectedColumns.push(this.selectedYAxisKey.trim());
        }
        if (typeof this.selectedZAxisKey === "string" && this.selectedZAxisKey.trim() !== "") {
          selectedColumns.push(this.selectedZAxisKey.trim());
        }
        if (typeof this.selectedColorGroupKey === "string" && this.selectedColorGroupKey.trim() !== "") {
          selectedColumns.push(this.selectedColorGroupKey.trim());
        }
        const chartsData = localStorage.getItem("savedChartData") || localStorage.getItem("newsavedChartData");
        const chartData = JSON.parse(chartsData);
        if (chartData) {
          // Add X Axis column if valid
          if (typeof chartData.XAxisColumn === "string" && chartData.XAxisColumn.trim() !== "") {
            selectedColumns.push(chartData.XAxisColumn.trim());
          }
          // Handle Y Axis column
          if (typeof chartData.YAxisColumn === "string" && chartData.YAxisColumn.trim() !== "") {
            // Split the string by commas, trim each value, and push to selectedColumns
            selectedColumns.push(
              ...chartData.YAxisColumn.split(",").map((key) => key.trim())
            );
          } else if (Array.isArray(chartData.YAxisColumn)) {
            // Push directly if it's an array
            selectedColumns.push(
              ...chartData.YAxisColumn
                .filter((key) => typeof key === "string" && key.trim() !== "")
                .map((key) => key.trim())
            );
          }
          // Add Z Axis key if valid
          if (typeof chartData.ZAxisColumn === "string" && chartData.ZAxisColumn.trim() !== "") {
            selectedColumns.push(chartData.ZAxisColumn.trim());
          }
        }
        this.chartTypeChange(chartData?.ChartType)
        // Add color group key if valid
        if (typeof chartData.GroupColumn === "string" && chartData.GroupColumn.trim() !== "") {
          selectedColumns.push(chartData.GroupColumn.trim());
        }

        // Add selectColumns to queryParams
        if (selectedColumns.length > 0) {
          queryParams.selectColumns = JSON.stringify(selectedColumns);
        }
        const queryString = Object.entries(queryParams)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");
        const response = await api.get(`public/api/tables/data/${selectedType}?${queryString}`,
          { signal: this.dataFetchAbortController.signal }
        );
        
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          if (response.data.error) {
            this.$emit("sample-error", response.data.error);
            return
          }
          
          // Clear all previous data before setting new data
          this.xAxisData = [];
          this.zAxisData = [];
          this.colorGroupData = [];
          // Don't clear yAxisData here - it will be properly set after data processing
          
          this.tableData = response.data.data.samples.rows;
          if (this.onlyApiCall === true) {
            return;
          }
          if (this.tableData === null) {
            this.$emit("sample-error", "Data is not available to plot chart.");
            return
          }
          const savedChartData = localStorage.getItem("savedChartData") || localStorage.getItem("newsavedChartData");
          const chartData = JSON.parse(savedChartData);

          if (chartData) {
            this.internalChartTitle = chartData.Name;
            var chartTitle = this.internalChartTitle;
            this.$emit("chart-title", chartTitle);
            this.selectedChartTypeName = chartData.ChartType;
            this.selectedTableTypeName = chartData.TableType;
            this.selectedColorGroupKey = chartData.GroupColumn;
            this.selectedXAxisKey = chartData.XAxisColumn;
            this.selectedZAxisKey = chartData.ZAxisColumn;
            this.xBins = 0;
            this.xBins = chartData.NumXBins;
            this.yBins = 0;
            this.yBins = chartData.NumYBins;
            this.$emit("update-x-bins", Number(this.xBins));
            this.$emit("update-y-bins", Number(this.yBins));
            
            // Restore scale values from saved chart data
            if (chartData.XAxisScale) {
              this.xAxisScale = chartData.XAxisScale;
              this.isXLog = chartData.XAxisScale === "log";
              this.$emit("x-axis-scale", this.xAxisScale);
            }
            if (chartData.YAxisScale) {
              this.yAxisScale = chartData.YAxisScale;
              this.isYLog = chartData.YAxisScale === "log";
              this.$emit("y-axis-scale", this.yAxisScale);
            }
            
            // Only restore Y-axis keys if current selection is empty (don't override user selections)
            if (chartData.YAxisColumn && (!this.selectedYAxisKey || this.selectedYAxisKey.length === 0) && !this.isUserSelecting) {
              var yAxisColumnArray = chartData.YAxisColumn.split(",").filter(item => item.trim() !== ""); // Remove any empty values
              
              // Filter out the legend/color group property from Y-axis selections
              yAxisColumnArray = this.filterLegendFromYAxis(yAxisColumnArray);
              
              // Only set Y-axis keys if current selection is empty
              this.selectedYAxisKey = yAxisColumnArray;
            }
          }
          // }
          // else {
          var chartTitle = this.internalChartTitle
          this.$emit("chart-title", chartTitle);
          this.$nextTick(() => {
            if (this.selectedXAxisKey) {
              const selectedColumn = this.xAxisItems.find(
                (item) => item.name === this.selectedXAxisKey
              );
              this.xAxisData = this.findXAxisData();
              var allCaptions = this.tableData?.map((row) => row.caption || ""); // Extract captions
              this.$emit("x-axis-selected", { data: this.xAxisData, displayName: selectedColumn ? selectedColumn.displayName : this.selectedXAxisKey, caption: allCaptions });
            }
            else {
              this.colorGroupData = [];
              this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
            }
            if (this.selectedYAxisKey.length > 0) {
              
              // Process Y-axis data
              this.yAxisData = this.findYAxisData();
              var allCaptions = this.tableData?.map((row) => row.caption || ""); // Extract captions
              
              // Get display names for all Y-axis keys
              const yAxisDisplayNames = this.selectedYAxisKey.map((key) => {
                const selectedColumn = this.yAxisItems.find(
                  (item) => item.name === key
                );
                return selectedColumn ? selectedColumn.displayName : key;
              });
              
              // Emit Y-axis data with all information
              this.$emit("y-axis-selected", { 
                data: this.yAxisData, 
                displayNames: yAxisDisplayNames, 
                caption: allCaptions 
              });
            }
            else {
               this.yAxisData = [];
              this.$emit("y-axis-selected", { data: [], displayNames: [] }); // Emit empty data
              this.colorGroupData = [];
              this.$emit("grouped-y-axis-data", { groupedYAxisData: [] });
              let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
              if (savedChartData) {
                savedChartData.YAxisColumn = "";
                localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
              }
              this.yAxisChanged = false;
            }
            if (this.selectedZAxisKey && this.selectedZAxisKey !== null && this.selectedZAxisKey !== undefined) {
              const selectedColumn = this.zAxisItems.find(
                (item) => item.name === this.selectedZAxisKey
              );
              
              // If no exact match found, try case-insensitive search
              const selectedColumnFallback = !selectedColumn && typeof this.selectedZAxisKey === 'string' ? this.zAxisItems.find(
                (item) => item.name.toLowerCase() === this.selectedZAxisKey.toLowerCase()
              ) : selectedColumn;
              
              this.zAxisData = this.findZAxisData();
              // Set the zAxisDisplayName property
              this.zAxisDisplayName = selectedColumnFallback ? selectedColumnFallback.displayName : this.selectedZAxisKey;
             
              this.$emit("z-axis-selected", { data: this.zAxisData, displayName: this.zAxisDisplayName });
            }
            else {
              this.colorGroupData = [];
              this.$emit("grouped-z-axis-data", { groupedZAxisData: [] });
              this.zAxisChanged = false;
            }
            
            // Process color group data immediately for edit mode
            this.processColorGroupDataForEditMode();
            
            // Reset user selection flag after data processing is complete
            this.resetUserSelectionFlag();
          });
          // }
        }
        else if (response && response.data && response.data.message) {
          this.$emit("sample-error", response.data.message);
        }
        else if (response && response.data && response.data.error) {
          this.$emit("sample-error", response.data.error);
        }
        else {
          // Handle unexpected response structure
          this.$emit("sample-error", "Unexpected response structure.");
        }
      } catch (error) {
        if (error.response && error.response.data) {
          let sampleError = error.response.data.error;
          this.$emit("sample-error", sampleError);
        } else {
          this.$emit("sample-error", "An error occurred while fetching data.");
        }
      } finally {
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
      }
    },
    chartTypeChange(selectedType) {
      this.chartType = selectedType;
      this.selectedChartTypeName = selectedType;
      
      // Emit the change to parent component
      this.$emit('chart-type-changed', selectedType);
      
      const selectedChart = this.chartTypes.find(
        (chart) => chart.Name === selectedType
      );
      
      if (selectedChart) {
        const originalSavedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        let savedChartData = originalSavedChartData || JSON.parse(localStorage.getItem("newsavedChartData"));
        
        if (savedChartData && savedChartData?.Name !== "" && savedChartData?.Name !== null) {
          this.internalChartTitle = savedChartData.Name;
        }
        
        // Set axis visibility based on chart type
        this.showXAxis = selectedChart.has_x;
        this.showYAxis = selectedChart.has_y;
        this.showZAxis = selectedChart.has_z;
        this.showColorGroup = selectedChart.has_group;
        this.showXBinsInput = selectedChart.has_x_bins;
        this.showYBinsInput = selectedChart.has_y_bins;
        
        // Handle X-axis bins
        if (this.showXBinsInput) {
          if (savedChartData && savedChartData?.NumXBins) {
            this.xBins = savedChartData.NumXBins;
          } else if (savedChartData) {
            if (this.chartType === "Histogram") {
              this.xBins = 10;
            } else {
              this.xBins = 20;
            }
              this.$emit("update-x-bins", Number(this.xBins));
            }
        } else {
          // Remove NumXBins from savedChartData if it exists
          if (savedChartData && savedChartData?.NumXBins) {
            delete savedChartData.NumXBins;
            if (originalSavedChartData) {
              localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
            }
          }
        }
        
        // Handle Y-axis bins
        if (this.showYBinsInput) {
          if (savedChartData?.NumYBins) {
            this.yBins = savedChartData.NumYBins;
          } else if (savedChartData) {
            this.yBins = 20;
            savedChartData.NumYBins = this.yBins;
            if (originalSavedChartData) {
              localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
            }
          }
        } else {
          // Remove NumYBins from savedChartData if it exists
          if (savedChartData?.NumYBins) {
            delete savedChartData.NumYBins;
            if (originalSavedChartData) {
              localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
            }
          }
        }
        
        // Handle color grouping
        if (this.showColorGroup == true && savedChartData && savedChartData?.GroupColumn !== "" && savedChartData?.GroupColumn !== null) {
          // Always set the color group key in edit mode, regardless of colorGroupChanged flag
          this.selectedColorGroupKey = savedChartData.GroupColumn;
         }
        if (this.colorGroupChanged == true) {
          savedChartData.GroupColumn = this.selectedColorGroupKey;
        }
        if (this.showColorGroup == false) {
          this.selectedColorGroupKey = null;
          this.$emit("grouped-y-axis-data", { groupedYAxisData: [] });
          this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
          this.$emit("grouped-z-axis-data", { groupedZAxisData: [] });
        }
        
        this.selectedChartTypeName = selectedChart.Name;
        
        // Handle X-axis
        if (this.showXAxis == true && savedChartData && savedChartData?.XAxisColumn !== "" && savedChartData?.XAxisColumn !== null && this.xAxisChanged == false) {
          this.selectedXAxisKey = savedChartData.XAxisColumn;
        }
        if (this.xAxisChanged == true && this.selectedXAxisKey) {
          savedChartData.XAxisColumn = this.selectedXAxisKey;
        }
        
        // Handle Y-axis
        var yAxisColumnArray = savedChartData?.YAxisColumn?.split(",").filter(item => item.trim() !== ""); // Remove any empty values
        if (this.showYAxis == true && savedChartData && savedChartData?.YAxisColumn !== "" && savedChartData?.YAxisColumn !== null && this.yAxisChanged == false) {
          if (originalSavedChartData) {
            // Removed the logic that limits Y-axis selections when color group is selected
            // This was preventing multiple Y-axis selections from working with legend
            this.selectedYAxisKey = yAxisColumnArray;
          }
        }
        if (this.yAxisChanged == true) {
          if (originalSavedChartData) {
            // Removed the logic that limits Y-axis selections when color group is selected
            // This was preventing multiple Y-axis selections from working with legend
            yAxisColumnArray = this.selectedYAxisKey;
          }
        }
        
        // Special handling for Histogram - ensure Y-axis is populated
        if (this.showYAxis == false && savedChartData.ChartType !== 'Histogram') {
          this.selectedYAxisKey = [];
          this.handleYAxisSelection();
          if (savedChartData) {
            savedChartData.YAxisColumn = this.selectedYAxisKey?.join(",");
            if (originalSavedChartData) {
              localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
            }
          }
        }
        
        // Handle Z-axis
        if (this.showZAxis == true && savedChartData && savedChartData?.ZAxisColumn !== "" && savedChartData?.ZAxisColumn !== null && this.zAxisChanged == false) {
          this.selectedZAxisKey = savedChartData.ZAxisColumn;
        }
        if (this.zAxisChanged == true) {
          savedChartData.ZAxisColumn = this.selectedZAxisKey;
        }
        
        this.$emit("chart-type-changed", selectedType);
        this.saveChartData();
        
        if (savedChartData) {
          savedChartData.ChartType = selectedType;
          if (originalSavedChartData) {
            localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
          }
        }
        
      } else {
        console.error("Selected chart not found.");
      }
    },
    async savedChartChange() {
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      let defaultFilterID = localStorage.getItem("defaultFilter");
      const selectedChart = this.savedCharts.find(
        (chart) => chart.Name === this.selectedSavedChartName
      );
      if (selectedChart) {
        const chartId = selectedChart.ID;
        this.selectedChartId = selectedChart.ID;
        try {
          const response = await api.get(`public/api/charts/${chartId}`);
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            let selectedChartData = response.data.data.chart;
            this.accessLevel = selectedChartData.AccessLevel;
            this.isPublic = this.accessLevel === "public";
            this.isXLog = selectedChartData.XAxisScale === "log";
            this.handleXScaleToggleChange();
            this.isYLog = selectedChartData.YAxisScale === "log";
            this.handleYScaleToggleChange();
            await this.tableTypeChange(selectedChartData.TableType);
            localStorage.setItem("savedChartData", JSON.stringify(selectedChartData));
            localStorage.setItem("initialChartData", JSON.stringify(selectedChartData));
            localStorage.setItem("newsavedChartData", JSON.stringify(selectedChartData));
            this.filterFromChart = selectedChartData.Filter;
            if (this.filterFromChart) {
              if (this.filterFromChart.ID !== undefined) {
                localStorage.setItem("selectedFilterId", this.filterFromChart.ID)
              }
              // this.$refs.filters.isFilterSelected();
              return
            }
            if (selectedChart && defaultFilterID) {
              this.callDefaultFilter = true;
              return;
            }
            this.showLoaders = false;
            this.$emit("loading-state", this.showLoaders);
            this.$nextTick(() => {
              this.populateChartData(selectedChartData);
            });
            this.createNewChart = true;
          }
          else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
          }
          else {
            this.showSnackbar("error fetching chart data.", "error");
          }
        } catch (error) {
        }
      } else {
        console.error("Selected chart not found.");
      }
    },
    async savedChartChangeLoad(chartData) {
      this.$emit("sample-error", "");
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      const savedChartSelected = localStorage.getItem("savedChartData")
      if (savedChartSelected) {
        this.selectedSavedChartName = chartData.Name;
      }
      let selectedChartData = chartData;
      await this.tableTypeChange(selectedChartData.TableType);
      this.accessLevel = selectedChartData.AccessLevel
      this.isPublic = this.accessLevel === "public";
      this.isXLog = selectedChartData.XAxisScale === "log";
      this.handleXScaleToggleChange();
      this.isYLog = selectedChartData.YAxisScale === "log";
      this.handleYScaleToggleChange();
      let defaultFilterID = localStorage.getItem("defaultFilter");
      this.chartTypeChange(chartData?.ChartType)
      if (this.filterReset === false) {
        this.filterFromChart = chartData.Filter;
        if (this.filterFromChart) {
          if (this.filterFromChart.ID !== undefined) {
            localStorage.setItem("selectedFilterId", this.filterFromChart.ID)
          }
          return;
        }
      }
      else if (this.filterReset === true) {
        this.filterFromChart = null
      }
      if (defaultFilterID) {
        return;
      }
      this.showLoaders = false;
      this.$emit("loading-state", this.showLoaders);
      this.$nextTick(() => {
        this.populateChartData(selectedChartData);
      });
      this.createNewChart = true;
    },
    updateChartTitle() {
      var chartTitle = this.internalChartTitle;
      this.$emit("chart-title", chartTitle);
    },
    async populateChartData(chartData) {
      // Reset change flags when loading existing chart data
      this.colorGroupChanged = false;
      this.xAxisChanged = false;
      this.yAxisChanged = false;
      this.zAxisChanged = false;
      
      this.chartTitle = chartData.Name;
      var chartTitle = this.internalChartTitle;
      this.$emit("chart-title", chartTitle);
      this.selectedChartTypeName = chartData.ChartType;
      this.selectedTableTypeName = chartData.TableType;
      this.selectedColorGroupKey = chartData.GroupColumn;
      const selectedXAxisItem = this.xAxisItems.find(
        (item) => item.name === chartData.XAxisColumn
      );
      this.selectedXAxisKey = selectedXAxisItem ? selectedXAxisItem.name : null;

      if (this.tableData && chartData.XAxisColumn) {
        var columnData = this.tableData.map(
          (row) => row[chartData.XAxisColumn]
        );
        var allCaptions = this.tableData?.map((row) => row.caption || ""); // Extract caption data
        this.xAxisData = columnData;
        this.$emit("x-axis-selected", { data: this.xAxisData, displayName: columnData ? columnData.displayName : chartData.XAxisColumn, caption: allCaptions });
      }
      else {
        this.colorGroupData = [];
        this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
      }
      if (typeof chartData.YAxisColumn === "string" && chartData.YAxisColumn.length > 0) {
        // Only restore Y-axis selections if current selection is empty (don't override user selections)
        if (!this.selectedYAxisKey || this.selectedYAxisKey.length === 0) {
          var yAxisColumnArray = chartData.YAxisColumn.split(",");
          // Removed the logic that removes the last element when color group is present
          // This was causing Y-axis selections to be reduced when legend was selected
          this.selectedYAxisKey = yAxisColumnArray.map((yAxisColumnName) => {
            const selectedYAxisItem = this.yAxisItems.find(
              (item) => item.name === yAxisColumnName
            );
            return selectedYAxisItem ? selectedYAxisItem.name : null;
          });
        } 
        // Process Y-axis data if table data is available
        if (this.tableData && this.selectedYAxisKey && this.selectedYAxisKey.length > 0) {
          var columnData = this.selectedYAxisKey.map((col) => {
            return this.tableData.map((row) => row[col]);
          });
          this.yAxisData = columnData;
          var allCaptions = this.tableData?.map((row) => row.caption || ""); // Extract caption data
          this.$emit("y-axis-selected", { data: this.yAxisData, caption: allCaptions });
        }
      } else {
        // Only clear Y-axis if current selection is empty
        if (!this.selectedYAxisKey || this.selectedYAxisKey.length === 0) {
          this.selectedYAxisKey = [];
        }
      }
      const selectedZAxisItem = this.zAxisItems.find(
        (item) => item.name === chartData.ZAxisColumn
      );
      this.selectedZAxisKey = selectedZAxisItem ? selectedZAxisItem.name : null;

      this.chartTypeChange(this.selectedChartTypeName);
      this.xBins = chartData.NumXBins || 20;
      this.yBins = chartData.NumYBins || 20;
      this.$emit("update-x-bins", Number(this.xBins));
      this.$emit("update-y-bins", Number(this.yBins));
      
      // Ensure color group data is properly processed after all data is set up
      if (this.selectedColorGroupKey && this.selectedColorGroupKey.length > 0) {
        // Process the color grouping data
        this.colorGroupData = this.findcolorGroupData();
        
        if (this.colorGroupData && this.colorGroupData.length > 0) {
          // Initialize grouped data objects
          const groupedYAxisData = {};
          const groupedXAxisData = {};
          const groupedZAxisData = {};
          
          // Initialize the grouped arrays for each unique value
          this.colorGroupData.forEach(value => {
            groupedYAxisData[value] = [];
            groupedXAxisData[value] = [];
            groupedZAxisData[value] = [];
          });
          
          // Group the data
          this.tableData.forEach(row => {
            const colorGroupValue = row[this.selectedColorGroupKey];
            if (this.colorGroupData.includes(colorGroupValue)) {
              const yAxisRowData = this.selectedYAxisKey.map(key => {
                const decimalKey = `${key}_decimal`;
                if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
                  const value = parseFloat(row[key]);
                  if (!isNaN(value)) {
                    const maxDecimals = Math.min(row[decimalKey], 6);
                    return value.toFixed(maxDecimals);
                  }
                }
                return row[key];
              });
              groupedYAxisData[colorGroupValue].push(yAxisRowData);
              
              const xAxisRowData = row[this.selectedXAxisKey];
              groupedXAxisData[colorGroupValue].push(xAxisRowData);
              
              if (this.selectedZAxisKey) {
                const zAxisRowData = row[this.selectedZAxisKey];
                groupedZAxisData[colorGroupValue].push(zAxisRowData);
              }
            }
          });
          
          // Emit grouped data
          this.$emit("grouped-y-axis-data", groupedYAxisData);
          this.$emit("grouped-x-axis-data", groupedXAxisData);
          this.$emit("grouped-z-axis-data", groupedZAxisData);
          this.$emit("color-group-key", this.selectedColorGroupKey);
          
          // Emit color group display name
          const selectedColorGroupItem = this.colorGroupItems?.find(item => item.name === this.selectedColorGroupKey);
          const colorGroupDisplayName = selectedColorGroupItem ? selectedColorGroupItem.displayName : this.selectedColorGroupKey;
          this.$emit("color-group-display-name", colorGroupDisplayName);
          
          // IMPORTANT: Also emit regular Y-axis data for the plot to work
          // The plot needs both regular data and grouped data when legend is selected
          if (this.selectedYAxisKey && this.selectedYAxisKey.length > 0) {
            const yAxisDisplayNames = this.selectedYAxisKey.map((key) => {
              const selectedColumn = this.yAxisItems.find(
                (item) => item.name === key
              );
              return selectedColumn ? selectedColumn.displayName : key;
            });
            var allCaptions = this.tableData?.map((row) => row.caption || "");
            this.$emit("y-axis-selected", { 
              data: this.yAxisData, 
              displayNames: yAxisDisplayNames, 
              caption: allCaptions 
            });
          }
          
          // Emit scale values to ensure they are applied to the chart
          if (this.xAxisScale) {
            this.$emit("x-axis-scale", this.xAxisScale);
          }
          if (this.yAxisScale) {
            this.$emit("y-axis-scale", this.yAxisScale);
          }
          
        }
      }
      this.updateAxisSelections();
      // localStorage.setItem("savedChartData", JSON.stringify(chartData));
      
      // Process color group data for edit mode
      this.processColorGroupDataForEditMode();
    },
    updateAxisSelections() {
      this.handleXAxisSelection();
      this.handleYAxisSelection();
      this.handleZAxisSelection();
    },
    findYAxisData() {
      if (!this.tableData || !this.tableData.length) {
        return [];
      }
      
      if (!this.selectedYAxisKey || !this.selectedYAxisKey.length) {
        return [];
      }
      
      // Define firstRow properly
      const firstRow = this.tableData[0];
      
      this.selectedYAxisKey.forEach(col => {
        const exactMatch = col in firstRow;
        const caseInsensitiveMatch = Object.keys(firstRow).find(key => 
          key.toLowerCase() === col.toLowerCase()
        );
        const partialMatch = Object.keys(firstRow).find(key => 
          key.includes(col) || col.includes(key)
        );
        
      });
      var columnData = this.selectedYAxisKey.map((col, colIndex) => {
        
        // Try to find the actual column name in the data
        let actualColumnName = col;
        if (!(col in firstRow)) {
          // Try case-insensitive match
          const caseInsensitiveMatch = Object.keys(firstRow).find(key => 
            key.toLowerCase() === col.toLowerCase()
          );
          if (caseInsensitiveMatch) {
            actualColumnName = caseInsensitiveMatch;
            } else {
            // Try partial match
            const partialMatch = Object.keys(firstRow).find(key => 
              key.includes(col) || col.includes(key)
            );
            if (partialMatch) {
              actualColumnName = partialMatch;
            } else {
          
              // Try to find similar column names
              const similarKeys = Object.keys(firstRow).filter(key => 
                key.toLowerCase().includes(col.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) ||
                col.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(key.toLowerCase())
              );
              if (similarKeys.length > 0) {
                actualColumnName = similarKeys[0]; // Use the first similar key
              }
            }
          }
        }
        
        const decimalKey = `${actualColumnName}_decimal`;
        
        const rawData = this.tableData.map((row, rowIndex) => {
          const value = row[actualColumnName];
          const decimalValue = row[decimalKey];
          
          // Handle decimal formatting
          if (decimalValue !== undefined && decimalValue !== null) {
            const numValue = parseFloat(value);
            if (!isNaN(numValue)) {
              const maxDecimals = Math.min(decimalValue, 6);
              const numericValue = parseFloat(numValue.toFixed(maxDecimals)); // Convert back to number
            
              return numericValue;
            }
          }
          return value;
        });
        
        
        return rawData;
      });
      return columnData;
    },
    findXAxisData() {
      
      if (!this.tableData || !this.tableData.length) {
        return [];
      }
      
      if (!this.selectedXAxisKey) {
        return [];
      }
      
      // Detailed analysis of the first row structure
      const firstRow = this.tableData[0];
      
      
      const exactMatch = this.selectedXAxisKey in firstRow;
      const caseInsensitiveMatch = Object.keys(firstRow).find(key => 
        key.toLowerCase() === this.selectedXAxisKey.toLowerCase()
      );
      const partialMatch = Object.keys(firstRow).find(key => 
        key.includes(this.selectedXAxisKey) || this.selectedXAxisKey.includes(key)
      );
      
      // Try to find the actual column name in the data
      let actualColumnName = this.selectedXAxisKey;
      if (!(this.selectedXAxisKey in firstRow)) {
        // Try case-insensitive match
        if (caseInsensitiveMatch) {
          actualColumnName = caseInsensitiveMatch;
        } else if (partialMatch) {
          // Try partial match
          actualColumnName = partialMatch;
          } 
      }
      
      const decimalKey = `${actualColumnName}_decimal`;
      
      const rawData = this.tableData.map((row, index) => {
        const value = row[actualColumnName];
        const decimalValue = row[decimalKey];

        
        // Handle decimal formatting
        if (decimalValue !== undefined && decimalValue !== null) {
          const numValue = parseFloat(value);
          if (!isNaN(numValue)) {
            const maxDecimals = Math.min(decimalValue, 6);
            const formattedValue = numValue.toFixed(maxDecimals);
            return formattedValue;
          }
        }
        return value;
      });
      
      return rawData;
    },
    findZAxisData() {
      if (this.tableData && this.selectedZAxisKey) {
        const decimalKey = `${this.selectedZAxisKey}_decimal`;
        return this.tableData.map((row) => {
          if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
            const value = parseFloat(row[this.selectedZAxisKey]);
            if (!isNaN(value)) {
              // Limit decimal places to prevent excessive digits
              const maxDecimals = Math.min(row[decimalKey], 6);
              return parseFloat(value.toFixed(maxDecimals)); // Convert back to number
            }
          }
          return row[this.selectedZAxisKey];
        });
      }
      return [];
    },
    findcolorGroupData() {
      if (this.tableData && this.selectedColorGroupKey) {
        var columnData = this.tableData.map(row => row[this.selectedColorGroupKey]);
        const uniqueValues = [...new Set(columnData.filter(item => item !== undefined && item !== null))];
        return uniqueValues;
      }
      return [];
    },
    saveChartData() {
      const chartData = {
        AccessLevel: this.accessLevel,
        ChartType: this.selectedChartTypeName || "",
        GroupColumn: this.selectedColorGroupKey || null,
        Name: this.internalChartTitle || "", // Use the current chart title
        TableType: this.selectedTableTypeName || "",
        XAxisColumn: this.selectedXAxisKey || null,
        YAxisColumn: this.selectedYAxisKey?.join(",") || null, // Join multiple Y-Axis keys
        ZAxisColumn: this.selectedZAxisKey || null,
        ...(this.selectedChartTypeName === "Histogram" || this.selectedChartTypeName === "2D Histogram"
          ? {
            NumXBins: Number(this.xBins),
            NumYBins: Number(this.yBins),
          }
          : {}),
      };
      localStorage.setItem("newsavedChartData", JSON.stringify(chartData));
    },
    handleXSelection() {
      this.xAxisChanged = true;
      this.handleXAxisSelection()
    },
    async handleXAxisSelection() {
      this.axisSelected = true;
      
      if (this.selectedXAxisKey) {
        // Cancel any pending X-axis API request
        if (this.yAxisChanged === false) {
          if (this.xAxisAbortController) {
            this.xAxisAbortController.abort();
          }
          // Create a new AbortController for the current X-axis request
          this.xAxisAbortController = new AbortController();
          const signal = this.xAxisAbortController.signal;

          let defaultFilterID = localStorage.getItem("defaultFilter");
          let filterActive = localStorage.getItem("filterActive");
          let selectedFilterId = localStorage.getItem("selectedFilterId");
          
          this.saveChartData();
          
          // Check for both saved filters and pending filters
          const pendingFilterData = localStorage.getItem("pendingFilterData");
          const pendingFilterActive = localStorage.getItem("filterActive");
          
          if (defaultFilterID || filterActive || selectedFilterId || (pendingFilterData && pendingFilterActive === "true")) {
            let filterData = this.savedFilterData;
            let type = this.savedType;
            
            // Use pending filter data if available and no saved filter data
            if (pendingFilterData && pendingFilterActive === "true" && (!filterData || Object.keys(filterData).length === 0)) {
              try {
                filterData = JSON.parse(pendingFilterData);
              } catch (error) {
                console.error("Error parsing pending filter data:", error);
              }
            }
            
            this.onlyApiCall = true;
            await this.getTableDataAgainstFilter({ filterData, type }, signal);
          } else {
            await this.getTableData(signal);
          }
        }
        
        // Extract all data from the single API response
        await this.extractAllAxisData();
        
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.XAxisColumn = this.selectedXAxisKey;
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
        this.xAxisChanged = false;
      } else {
        this.colorGroupData = [];
        this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
        this.xAxisChanged = false;
      }
    },
    handleYSelection() {
      this.yAxisChanged = true;
      this.isUserSelecting = true; // Set flag to indicate user is making selections
      this.handleYAxisSelection()
    },
    async handleYAxisSelection() {
      
      // Only call handleXAxisSelection if X-axis data is not already available
      if (!this.xAxisData || this.xAxisData.length === 0) {
        this.handleXAxisSelection();
        return; // Exit early as handleXAxisSelection will handle everything
      }
      
      this.axisSelected = true;
      
      if (this.selectedYAxisKey.length > 0) {
        // Cancel any pending Y-axis API request
        if (this.yAxisAbortController) {
          this.yAxisAbortController.abort();
        }

        // Create a new AbortController for the current Y-axis request
        this.yAxisAbortController = new AbortController();
        const signal = this.yAxisAbortController.signal;

        let defaultFilterID = localStorage.getItem("defaultFilter");
        let filterActive = localStorage.getItem("filterActive");
        let selectedFilterId = localStorage.getItem("selectedFilterId");
        
        this.saveChartData();
        
        // Check for both saved filters and pending filters
        const pendingFilterData = localStorage.getItem("pendingFilterData");
        const pendingFilterActive = localStorage.getItem("filterActive");
        
        if (defaultFilterID || filterActive || selectedFilterId || (pendingFilterData && pendingFilterActive === "true")) {
          let filterData = this.savedFilterData;
          let type = this.savedType;
          
          // Use pending filter data if available and no saved filter data
          if (pendingFilterData && pendingFilterActive === "true" && (!filterData || Object.keys(filterData).length === 0)) {
            try {
              filterData = JSON.parse(pendingFilterData);
            } catch (error) {
              console.error("Error parsing pending filter data:", error);
            }
          }
          
          this.onlyApiCall = true;
          await this.getTableDataAgainstFilter({ filterData, type }, signal);
        } else {
          await this.getTableData(signal);
        }
        
        if (this.selectedYAxisKey.length > 1) {
          // Removed the logic that clears color group when multiple Y-axis items are selected
          // This was preventing legend from working with multiple Y-axis selections
          
          // Filter out any legend properties from Y-axis selections
          this.selectedYAxisKey = this.filterLegendFromYAxis(this.selectedYAxisKey);
          
          let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
          if (savedChartData) {
            savedChartData.GroupColumn = this.selectedColorGroupKey;
            localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
          }
        }
        
        // Extract all data from the single API response
        await this.extractAllAxisData();
        
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.YAxisColumn = this.selectedYAxisKey.join(",");
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
        this.yAxisChanged = false;
      } else {
        // Handle case when no items are selected for the y-axis
        this.yAxisData = [];
        this.$emit("y-axis-selected", { data: [], displayNames: [] }); // Emit empty data
        this.colorGroupData = [];
        this.$emit("grouped-y-axis-data", { groupedYAxisData: [] });
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.YAxisColumn = "";
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
        this.yAxisChanged = false;
      }
    },
    handleZSelection() {
      this.zAxisChanged = true;
      this.handleZAxisSelection()
    },
    async handleZAxisSelection() {
      // Only call handleXAxisSelection if X-axis data is not already available
      if (!this.xAxisData || this.xAxisData.length === 0) {
        this.handleXAxisSelection();
        return; // Exit early as handleXAxisSelection will handle everything
      }
      // Only call handleYAxisSelection if Y-axis data is not already available
      if (!this.yAxisData || this.yAxisData.length === 0) {
        this.handleYAxisSelection();
        return; // Exit early as handleYAxisSelection will handle everything
      }
      this.axisSelected = true;
      if (this.selectedZAxisKey) {
        // Cancel any pending Z-axis API request
        if (this.zAxisAbortController) {
          this.zAxisAbortController.abort();
        }
        // Create a new AbortController for the current Z-axis request
        this.zAxisAbortController = new AbortController();
        const signal = this.zAxisAbortController.signal;

        let defaultFilterID = localStorage.getItem("defaultFilter");
        let filterActive = localStorage.getItem("filterActive")
        let selectedFilterId = localStorage.getItem("selectedFilterId")
        this.saveChartData();
        // Check for both saved filters and pending filters
        const pendingFilterData = localStorage.getItem("pendingFilterData");
        const pendingFilterActive = localStorage.getItem("filterActive");
        
        if (defaultFilterID || filterActive || selectedFilterId || (pendingFilterData && pendingFilterActive === "true")) {
          let filterData = this.savedFilterData
          let type = this.savedType
          
          // Use pending filter data if available and no saved filter data
          if (pendingFilterData && pendingFilterActive === "true" && (!filterData || Object.keys(filterData).length === 0)) {
            try {
              filterData = JSON.parse(pendingFilterData);
            } catch (error) {
              console.error("Error parsing pending filter data:", error);
            }
          }
          
          this.onlyApiCall = true
          await this.getTableDataAgainstFilter({ filterData, type }, signal);
        }
        else {
          await this.getTableData(signal);
        }
        
        // Extract all data from the single API response
        await this.extractAllAxisData();
        
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.ZAxisColumn = this.selectedZAxisKey
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
        this.zAxisChanged = false;
      }
      else {
        this.colorGroupData = [];
        this.$emit("grouped-z-axis-data", { groupedZAxisData: [] });
        this.zAxisChanged = false;
      }
    },
    handleColorGroupSelection() {
      this.axisSelected = true;
      this.colorGroupChanged = true;
      
      // Add debouncing to prevent multiple rapid API calls
      if (this.colorGroupSelectionTimeout) {
        clearTimeout(this.colorGroupSelectionTimeout);
      }
      
      this.colorGroupSelectionTimeout = setTimeout(() => {
        this.handleGroupSelection();
      }, 300); // 300ms debounce
    },
    async handleGroupSelection() {
      if (this.selectedColorGroupKey && this.selectedColorGroupKey.length > 0) {
        if (this.colorGroupChanged) {
          // Cancel any pending color grouping API request
          if (this.colorGroupAbortController) {
            this.colorGroupAbortController.abort();
          }
          // Create a new AbortController for the current color grouping request
          this.colorGroupAbortController = new AbortController();
          const signal = this.colorGroupAbortController.signal;

          let defaultFilterID = localStorage.getItem("defaultFilter");
          let filterActive = localStorage.getItem("filterActive")
          let selectedFilterId = localStorage.getItem("selectedFilterId")
          this.saveChartData();
          
          try {
            // Check for both saved filters and pending filters
            const pendingFilterData = localStorage.getItem("pendingFilterData");
            const pendingFilterActive = localStorage.getItem("filterActive");
            
            if (defaultFilterID || filterActive || selectedFilterId || (pendingFilterData && pendingFilterActive === "true")) {
              let filterData = this.savedFilterData
              let type = this.savedType
              
              // Use pending filter data if available and no saved filter data
              if (pendingFilterData && pendingFilterActive === "true" && (!filterData || Object.keys(filterData).length === 0)) {
                try {
                  filterData = JSON.parse(pendingFilterData);
                } catch (error) {
                  console.error("Error parsing pending filter data:", error);
                }
              }
              
              this.onlyApiCall = true
              await this.getTableDataAgainstFilter({ filterData, type }, signal);
            }
            else {
              await this.getTableData(signal);
            }
            
            // After API call, extract all data from the single response
            // This will handle the color grouping logic
            await this.extractAllAxisData();
          } catch (error) {
            if (error.name === 'AbortError') {
              return;
            }
            console.error('Error in color group API call:', error);
            this.$emit("sample-error", "Error updating chart data for color grouping.");
            return;
          }
        }
        this.colorGroupChanged = false;
      }
      else {
        // Handle case when color group is removed/cleared
        if (this.colorGroupChanged) {
          // Cancel any pending color grouping API request
          if (this.colorGroupAbortController) {
            this.colorGroupAbortController.abort();
          }
          // Create a new AbortController for the current color grouping request
          this.colorGroupAbortController = new AbortController();
          const signal = this.colorGroupAbortController.signal;

          this.saveChartData();
          
          let defaultFilterID = localStorage.getItem("defaultFilter");
          let filterActive = localStorage.getItem("filterActive")
          let selectedFilterId = localStorage.getItem("selectedFilterId")
          
          try {
            // Check for both saved filters and pending filters
            const pendingFilterData = localStorage.getItem("pendingFilterData");
            const pendingFilterActive = localStorage.getItem("filterActive");
            
            if (defaultFilterID || filterActive || selectedFilterId || (pendingFilterData && pendingFilterActive === "true")) {
              let filterData = this.savedFilterData
              let type = this.savedType
              
              // Use pending filter data if available and no saved filter data
              if (pendingFilterData && pendingFilterActive === "true" && (!filterData || Object.keys(filterData).length === 0)) {
                try {
                  filterData = JSON.parse(pendingFilterData);
                } catch (error) {
                  console.error("Error parsing pending filter data:", error);
                }
              }
              
              this.onlyApiCall = true
              await this.getTableDataAgainstFilter({ filterData, type }, signal);
            }
            else {
              await this.getTableData(signal);
            }
            
            // After API call, extract all data from the single response
            // This will handle clearing the color grouping
            await this.extractAllAxisData();
          } catch (error) {
            if (error.name === 'AbortError') {
              return;
            }
            console.error('Error in color group removal API call:', error);
            this.$emit("sample-error", "Error updating chart data after removing color grouping.");
            return;
          }
        }
        this.colorGroupChanged = false;
      }
    },
    resetAxisSelections() {
      this.selectedXAxisKey = [];
      this.selectedYAxisKey = [];
      this.selectedZAxisKey = [];
      const containsSampleUID = this.colorGroupItems.some(
        item => item.displayName === "Sample UID"
      );
      if (containsSampleUID) {
        this.sampleIdPresent = true;
      } else {
        this.selectedColorGroupKey = null;
      }
      this.$emit("grouped-y-axis-data", { groupedYAxisData: [] });
      this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
      this.$emit("grouped-z-axis-data", { groupedZAxisData: [] });
      this.xAxisData = [];
      this.$emit("x-axis-selected", { data: this.xAxisData });
      this.yAxisData = [];
      this.$emit("y-axis-selected", { data: this.yAxisData });
      this.zAxisData = [];
      this.zAxisDisplayName = "";
      this.$emit("z-axis-selected", { data: this.zAxisData, displayName: this.zAxisDisplayName });
    },
    async getChartTypes() {
      this.loadingChartType = true;
      await api
        .get("public/api/charts/type")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.chartTypes = response.data.data.chart_types;
            this.chartTypesNames = response.data.data.chart_types.map(
              (chart) => chart.Name
            );
            this.filteredChartTypesNames = this.chartTypesNames
          }
          else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
          }
          else {
            this.showSnackbar("error fetching chart types.", "error");
          }
        })
        .catch((error) => {
        })
        .finally(() => {
          this.loadingChartType = false;
        });
    },
    getTableTypes() {
      this.showLoaders = true;
      this.loadingTableType = true;
      api
        .get("public/api/tables/type")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.tableTypes = response.data.data.tableTypes;
            this.tableTypesNames = response.data.data.tableTypes.map(
              (chart) => chart.table
            );
            this.filteredTableTypesNames = this.tableTypesNames;
          }
          else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
          }
          else {
            this.showSnackbar("error fetching table types.", "error");
          }
        })
        .catch((error) => {
        })
        .finally(() => {
          this.showLoaders = false;
          this.loadingTableType = false;
        });
    },
    handleToggleChange() {
      // Update access level based on the switch state
      this.accessLevel = this.isPublic ? "public" : "private";
    },
    handleAccessLevelChange(newAccessLevel) {
      this.accessLevel = newAccessLevel;
      this.isPublic = newAccessLevel === "public";
    },
    async createChart(access) {
      
      this.createLoading = true;
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      
      const chartType = this.selectedChartTypeName || "";
      const tableType = this.selectedTableTypeName || "";
      const selectedChartType = this.chartTypes.find(
        (chart) => chart.Name === chartType
      );
      
      // Initialize YAxisColumns as an array and include selectedYAxisKey values if showYAxis is true
      let YAxisColumns = this.showYAxis ? [...this.selectedYAxisKey] : [];

      // Add GroupColumn data to YAxisColumns if available
      if (this.showColorGroup && this.selectedColorGroupKey) {
        YAxisColumns.push(this.selectedColorGroupKey);
      }
      
      // Always get filters when creating a chart - remove the problematic lastView condition
      var Filters = {};
      try {
        // Wait for next tick to ensure filter component is properly mounted
        await this.$nextTick();
        
        if (this.$refs.filters) {
          Filters = this.$refs.filters.saveFilterWithChart();
          
          // Check if filters have actual data
          if (Filters && Object.keys(Filters).length > 0) {
          } else {
            console.warn('Filters object is empty or contains no data - this is normal for new charts')
            // Ensure we still have a valid filter object structure
            Filters = {
              ID: null,
              name: '',
              asset: [],
              field: [],
              reservoir: [],
              well: [],
              sampleDate: null,
              fluidType: [],
              sampleType: [],
              fluidClassification: [],
              fluidSampleID: [],
              fluidSampleContainerID: [],
              source: '',
              user: this.userFullName || '',
              public: true
            };
          }
        } else {
          console.warn('Filters component reference not found - this.$refs.filters is undefined');
          // Create a default filter structure if filters component is not available
          Filters = {
            ID: null,
            name: '',
            asset: [],
            field: [],
            reservoir: [],
            well: [],
            sampleDate: null,
            fluidType: [],
            sampleType: [],
            fluidClassification: [],
            fluidSampleID: [],
            fluidSampleContainerID: [],
            source: '',
            user: this.userFullName || '',
            public: true
          };
        }
      } catch (error) {
        console.error('Error getting filters:', error);
        // Create a default filter structure on error
        Filters = {
          ID: null,
          name: '',
          asset: [],
          field: [],
          reservoir: [],
          well: [],
          sampleDate: null,
          fluidType: [],
          sampleType: [],
          fluidClassification: [],
          fluidSampleID: [],
          fluidSampleContainerID: [],
          source: '',
          user: this.userFullName || '',
          public: true
        };
      }
      
      const requestData = {
        data: {
          chart: {
            name: this.internalChartTitle,
            ChartType: chartType,
            TableType: tableType,
            XAxisColumn: this.selectedXAxisKey,
            AccessLevel: access,
            Filter: Filters,
            XAxisScale: this.xAxisScale,
            YAxisScale: this.yAxisScale,
          },
        },
      };
      
      if (this.showYAxis && YAxisColumns.length > 0) {
        requestData.data.chart.YAxisColumns = YAxisColumns;
      }
      if (this.showZAxis && this.selectedZAxisKey) {
        requestData.data.chart.ZAxisColumn = this.selectedZAxisKey;
      }
      if (selectedChartType && selectedChartType.has_x_bins) {
        requestData.data.chart.NumXBins = this.xBinsAsNumber;
      }
      if (selectedChartType && selectedChartType.has_y_bins) {
        requestData.data.chart.NumYBins = this.yBinsAsNumber;
      }
      if (this.showColorGroup && this.selectedColorGroupKey) {
        requestData.data.chart.GroupColumn = this.selectedColorGroupKey;
      }
      
      
      api
        .post("public/api/charts", requestData)
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.createLoading = false;
            this.showLoaders = false;
            this.$emit("loading-state", this.showLoaders);
            this.accessLevel = requestData.data.chart.AccessLevel;
            this.showSnackbar(response.data.message || "Chart created successfully!", "success");
            
            // Clear pending filters after successful chart creation
            if (this.$refs.filters) {
              this.$refs.filters.clearPendingFilters();
            }
            
            this.getSavedCharts();
            this.$emit("chart-saved-studio", requestData.data.chart);
            this.createNewChart = true;
            this.selectedSavedChartName = requestData.data.chart.name;
            let chartId = response.data.data.ID;
            this.getChartById(chartId);
          } else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
            this.createLoading = false;
            this.showLoaders = false;
            this.$emit("loading-state", this.showLoaders);
          } else {
            this.showSnackbar("Error creating chart.", "error");
            this.createLoading = false;
            this.showLoaders = false;
            this.$emit("loading-state", this.showLoaders);
          }
          localStorage.removeItem("newsavedChartData");
        })
        .catch((error) => {
          console.error('Error creating chart:', error);
          this.createLoading = false;
          this.showLoaders = false;
          this.$emit("loading-state", this.showLoaders);
          if (error.response && error.response.data && error.response.data.error) {
          this.showSnackbar(error.response.data.error, "error");
          } else {
            this.showSnackbar("An error occurred while creating the chart.", "error");
          }
        });
    },
    async deleteChart() {
      const selectedChart = this.savedCharts.find(
        (chart) => chart.Name === this.selectedSavedChartName
      );
      if (!selectedChart) {
        console.error("Selected chart not found.");
        return;
      }
      this.deleteLoading = true;
      const chartId = selectedChart.ID;
      try {
        const response = await api.delete(`public/api/charts/${chartId}`);

        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.deleteLoading = false;
          this.showSnackbar(response.data.message, "success");
          this.getSavedCharts();
          this.resetChartData();
          this.chartSaved = true;
          this.$emit("chart-saved", this.chartSaved);
          this.confirmDeleteDialog = false;
        }
        else if (response && response.data && response.data.statusCode === 500) {
          this.deleteLoading = false;
          this.showSnackbar(response.data.error, "error");
        }
        else if (response && response.data && response.data.message) {
          this.deleteLoading = false;
          this.showSnackbar(response.data.message, "error");
        }
        else {
          this.deleteLoading = false;
          this.showSnackbar("error deleting chart.", "error");
        }
      } catch (error) {
        this.deleteLoading = false;
        if (error.response && error.response.data && error.response.data.error) {
          this.showSnackbar(error.response.data.error, "error");
        } else if (error.response && error.response.data && error.response.data.message) {
          this.showSnackbar(error.response.data.message, "error");
        } else {
          this.showSnackbar("An error occurred while deleting the chart.", "error");
        }
      }
    },
    async updateChart(accessLevel = null) {
      // If new value is passed, update accessLevel immediately
  if (accessLevel !== null) {
    this.accessLevel = accessLevel;
  }
      const selectedChart = this.savedCharts.find(
        (chart) => chart.Name === this.selectedSavedChartName
      );
      if (!selectedChart) {
        console.error("Selected chart not found.");
        return;
      }
      this.updateLoading = true;
      const chartId = selectedChart.ID;
      const chartType = this.selectedChartTypeName
        ? this.selectedChartTypeName
        : "";
      const tableType = this.selectedTableTypeName
        ? this.selectedTableTypeName
        : "";
      const selectedChartType = this.chartTypes.find(
        (chart) => chart.Name === chartType
      );
      let YAxisColumns = this.showYAxis ? [...this.selectedYAxisKey] : [];
      // Add GroupColumn data to YAxisColumns if available
      if (this.showColorGroup && this.selectedColorGroupKey) {
        YAxisColumns.push(this.selectedColorGroupKey);
      }
      const Filters = this.$refs.filters.saveFilterWithChart();
      const requestData = {
        data: {
          chart: {
            ID: chartId,
            name: this.internalChartTitle,
            ChartType: chartType,
            TableType: tableType,
            XAxisColumn: this.selectedXAxisKey,
            AccessLevel: this.accessLevel,
            Filter: Filters,
            XAxisScale: this.xAxisScale,
            YAxisScale: this.yAxisScale,
          },
        },
      };
      if (this.showYAxis) {
        requestData.data.chart.YAxisColumns = YAxisColumns;
      }
      if (this.showZAxis) {
        requestData.data.chart.ZAxisColumn = this.selectedZAxisKey;
      }
      if (selectedChartType && selectedChartType.has_x_bins) {
        requestData.data.chart.NumXBins = this.xBinsAsNumber;
      }
      if (selectedChartType && selectedChartType.has_y_bins) {
        requestData.data.chart.NumYBins = this.yBinsAsNumber;
      }
      if (this.showColorGroup && this.selectedColorGroupKey) {
        requestData.data.chart.GroupColumn = this.selectedColorGroupKey
      }
      if (this.showColorGroup && !this.selectedColorGroupKey) {
        requestData.data.chart.GroupColumn = ""
      }
        
      try {
        const response = await api.put(
          `public/api/charts/${chartId}`,
          requestData
        );
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.updateLoading = false;
          this.accessLevel = requestData.data.chart.AccessLevel;
          this.showSnackbar(response.data.message, "success");
          
          // Clear pending filters after successful chart update
          if (this.$refs.filters) {
            this.$refs.filters.clearPendingFilters();
          }
          
          this.getSavedCharts();
          // this.resetChartData();
          this.chartSaved = true;
          var chartSaved = this.chartSaved;
          this.$emit("chart-saved", chartSaved, requestData);
          this.getChartById(chartId);
          this.confirmUpdateDialog = false;
        }
        else if (response && response.data && response.data.message) {
          this.showSnackbar(response.data.message, "error");
          this.updateLoading = false;
        }
        else {
          this.updateLoading = false;
          this.showSnackbar("An error occurred while updating the chart.", "error");
        }
      } catch (error) {
        this.updateLoading = false;
        if (error.response && error.response.data && error.response.data.error) {
          this.showSnackbar(error.response.data.error, "error");
        } else if (error.response && error.response.data && error.response.data.message) {
          this.showSnackbar(error.response.data.message, "error");
        } else {
          this.showSnackbar("An error occurred while updating the chart.", "error");
        }
      }
    },
    async getChartById(chartId) {
      this.selectedChartId = chartId;
      try {
        const response = await api.get(
          `public/api/charts/${chartId}`
        );
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          let chartDataById = response.data.data.chart;
          this.selectedSavedChartName = chartDataById.Name
          localStorage.setItem("savedChartData", JSON.stringify(chartDataById));
          localStorage.setItem("initialChartData", JSON.stringify(chartDataById));
          localStorage.setItem("newsavedChartData", JSON.stringify(chartDataById));
          this.isUpdateEnabled = false;
          //     this.$nextTick(() => {
          //   this.isUpdateEnabled = this.checkIfUpdateEnabled();
          // });
          if (chartDataById.Filter.ID !== undefined) {
            localStorage.setItem("selectedFilterId", chartDataById.Filter.ID)
          }
          
          // Emit the complete chart data to parent component
          this.$emit("chart-fetched", chartDataById);
        }
        else if (response && response.data && response.data.message) {
          this.showSnackbar(response.data.message, "error");
        }
        else {
          this.showSnackbar("error fetching chart data.", "error");
        }
      } catch (error) {
        console.log(error)
      }
    },
    resetChartData() {
      this.showLoaders = true;
      this.internalChartTitle = "";
      this.resetAxisSelections();
      this.$emit("chart-type-changed", "");
      this.$emit("chart-title", "");
      this.showXBinsInput = false;
      this.showYBinsInput = false;
      this.showZAxis = false;
      this.showColorGroup = false;
      this.selectedTableTypeName = null;
      this.selectedChartTypeName = null;
      this.selectedXAxisKey = [];
      this.selectedYAxisKey = [];
      this.selectedZAxisKey = [];
      this.selectedSavedChartName = null;
      this.showLoaders = false;
      this.createNewChart = false;
      this.accessLevel = "private",
        this.isPublic = this.accessLevel === "public";
      this.xAxisScale = "linear";
      this.yAxisScale = "linear";
      this.isXLog = false;
      this.isYLog = false;
      this.$emit("x-axis-scale", this.xAxisScale);
      this.$emit("y-axis-scale", this.yAxisScale);
      localStorage.removeItem("savedChartData");
      localStorage.removeItem("initialChartData");
      localStorage.removeItem("selectedFilterId");
      this.showInputs = true;
      this.$refs.filters.resetFields();
      
      // Clear table data and other cached data
      this.tableData = [];
      this.colorGroupChanged = false;
      this.xAxisChanged = false;
      this.yAxisChanged = false;
      this.zAxisChanged = false;
      this.axisSelected = false;
      this.sampleIdPresent = false;
      this.onlyApiCall = false;
      
      // Clear display-related properties
      this.xAxisDisplayName = "";
      this.yAxisDisplayNames = [];
      this.zAxisDisplayName = "";
      this.xAxisCaption = [];
      this.yAxisCaption = [];
    },
    getSavedCharts() {
      this.showLoaders = true;
      this.loadingSavedCharts = true;
      api
        .get("public/api/charts")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            if (response.data.data.charts) {
              this.savedCharts = response.data.data.charts;
              this.savedChartsNames = response.data.data.charts.map(
                (chart) => chart.Name
              );
              this.filteredChartsNames = this.savedChartsNames;
            } else {
              this.resetChartData();
            }
          }
          else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
          }
          else {
            this.showSnackbar("error fetching charts.", "error");
          }
        })
        .catch((error) => {
        })
        .finally(() => {
          this.showLoaders = false;
          this.loadingSavedCharts = false;
        });
    },
    // Method to extract all axis data from a single API response to ensure synchronization
    async extractAllAxisData() {
      
      
      if (!this.tableData || this.tableData.length === 0) {
        return;
      }
      
      // Set loading state to prevent premature chart rendering
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      
      // Clear all previous data to ensure we're using only the latest API response
      this.xAxisData = [];
      this.yAxisData = [];
      this.zAxisData = [];
      this.colorGroupData = [];
      
      // Auto-fix column name mismatches before extraction
      this.autoFixColumnNames();
      
      // Check if we need to use chunked processing for large datasets
      const isLargeDataset = this.tableData.length > this.dataChunkSize;
      
      try {
      // Extract X-axis data
      if (this.selectedXAxisKey) {
        const selectedColumn = this.xAxisItems.find(
          (item) => item.name === this.selectedXAxisKey
        );
          
        // Use chunked processing for large datasets
        if (isLargeDataset) {
          this.xAxisData = await this.findXAxisDataChunked();
        } else {
          this.xAxisData = this.findXAxisData();
        }
        
        var allCaptions = this.tableData?.map((row) => row.caption || ""); // Extract caption data
        this.$emit("x-axis-selected", { 
          data: this.xAxisData, 
          displayName: selectedColumn ? selectedColumn.displayName : this.selectedXAxisKey, 
          caption: allCaptions 
        });
        } 
      
      // Extract Y-axis data
      if (this.selectedYAxisKey && this.selectedYAxisKey.length > 0) {
          
        // Use chunked processing for large datasets
        if (isLargeDataset) {
          this.yAxisData = await this.findYAxisDataChunked();
        } else {
          this.yAxisData = this.findYAxisData();
        }
        
        var allCaptions = this.tableData?.map((row) => row.caption || ""); // Extract caption data
        const yAxisDisplayNames = this.selectedYAxisKey.map((key) => {
          const selectedColumn = this.yAxisItems.find(
            (item) => item.name === key
          );
          return selectedColumn ? selectedColumn.displayName : key;
        });
          
          
        this.$emit("y-axis-selected", { 
          data: this.yAxisData, 
          displayNames: yAxisDisplayNames, 
          caption: allCaptions 
        });
        } 
      
      // Extract Z-axis data
      if (this.selectedZAxisKey && this.selectedZAxisKey !== null && this.selectedZAxisKey !== undefined) {
       
        const selectedColumn = this.zAxisItems.find(
          (item) => item.name === this.selectedZAxisKey
        );
        
        // If no exact match found, try case-insensitive search
        let selectedColumnFallback = !selectedColumn && typeof this.selectedZAxisKey === 'string' ? this.zAxisItems.find(
          (item) => item.name.toLowerCase() === this.selectedZAxisKey.toLowerCase()
        ) : selectedColumn;
        
        // If still no match, try partial match
        if (!selectedColumnFallback && typeof this.selectedZAxisKey === 'string') {
          selectedColumnFallback = this.zAxisItems.find(
            (item) => item.name.toLowerCase().includes(this.selectedZAxisKey.toLowerCase()) ||
                     this.selectedZAxisKey.toLowerCase().includes(item.name.toLowerCase())
          );
        }
        
        // Use chunked processing for large datasets
        if (isLargeDataset) {
          this.zAxisData = await this.findZAxisDataChunked();
        } else {
          this.zAxisData = this.findZAxisData();
        }
        
        // Set the zAxisDisplayName property
        this.zAxisDisplayName = selectedColumnFallback ? selectedColumnFallback.displayName : this.selectedZAxisKey;
        
        
        
        this.$emit("z-axis-selected", { 
          data: this.zAxisData, 
          displayName: this.zAxisDisplayName 
        });
        }
      
      
      // Handle color grouping logic directly here instead of calling handleGroupSelection
      if (this.selectedColorGroupKey && this.selectedColorGroupKey.length > 0) {
        this.colorGroupData = this.findcolorGroupData();
        
        if (this.selectedChartTypeName != "Histogram") {
          if (!this.yAxisData.length) {
            return;
          }
        }
        if (!this.xAxisData.length) {
          return;
        }
        
        // Initialize grouped data objects
        const groupedYAxisData = {};
        const groupedXAxisData = {};
        const groupedZAxisData = {};
        
        // Initialize the grouped arrays for each unique value
        this.colorGroupData.forEach(value => {
          groupedYAxisData[value] = [];
          groupedXAxisData[value] = [];
          groupedZAxisData[value] = [];
        });
        
        // Group the data
        this.tableData.forEach(row => {
          const colorGroupValue = row[this.selectedColorGroupKey];
          if (this.colorGroupData.includes(colorGroupValue)) {
            // Collect yAxis data
            const yAxisRowData = this.selectedYAxisKey.map(key => {
              const decimalKey = `${key}_decimal`;
              if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
                const value = parseFloat(row[key]);
                if (!isNaN(value)) {
                  const maxDecimals = Math.min(row[decimalKey], 6);
                  return value.toFixed(maxDecimals);
                }
              }
              return row[key];
            });
            groupedYAxisData[colorGroupValue].push(yAxisRowData);
            
            // Collect xAxis data
            const xAxisRowData = row[this.selectedXAxisKey];
            groupedXAxisData[colorGroupValue].push(xAxisRowData);
            
            // Collect zAxis data
            if (this.selectedZAxisKey) {
              const zAxisRowData = row[this.selectedZAxisKey];
              groupedZAxisData[colorGroupValue].push(zAxisRowData);
            }
          }
        });
        
        this.$emit("grouped-y-axis-data", groupedYAxisData);
        this.$emit("grouped-x-axis-data", groupedXAxisData);
        this.$emit("grouped-z-axis-data", groupedZAxisData);
        this.$emit("color-group-key", this.selectedColorGroupKey);
        
        // Emit color group display name
        const selectedColorGroupItem = this.colorGroupItems?.find(item => item.name === this.selectedColorGroupKey);
        const colorGroupDisplayName = selectedColorGroupItem ? selectedColorGroupItem.displayName : this.selectedColorGroupKey;
        this.$emit("color-group-display-name", colorGroupDisplayName);
        
        // IMPORTANT: Also emit regular Y-axis data for the plot to work
        // The plot needs both regular data and grouped data when legend is selected
        if (this.selectedYAxisKey && this.selectedYAxisKey.length > 0) {
          const yAxisDisplayNames = this.selectedYAxisKey.map((key) => {
            const selectedColumn = this.yAxisItems.find(
              (item) => item.name === key
            );
            return selectedColumn ? selectedColumn.displayName : key;
          });
          var allCaptions = this.tableData?.map((row) => row.caption || "");
          
          this.$emit("y-axis-selected", { 
            data: this.yAxisData, 
            displayNames: yAxisDisplayNames, 
            caption: allCaptions 
          });
        }
        
        // Emit scale values to ensure they are applied to the chart
        if (this.xAxisScale) {
          this.$emit("x-axis-scale", this.xAxisScale);
        }
        if (this.yAxisScale) {
          this.$emit("y-axis-scale", this.yAxisScale);
        }
        
      } else {
        // Clear grouped data when no color group is selected
        this.colorGroupData = [];
        this.$emit("grouped-y-axis-data", { groupedYAxisData: [] });
        this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
        this.$emit("grouped-z-axis-data", { groupedZAxisData: [] });
        
        // Update saved chart data
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.GroupColumn = ""
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
      }
        
        
        // Force a small delay to ensure all emissions are processed
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Now turn off loading state to allow chart rendering
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        
        // Force chart re-render by emitting a dummy event
        this.$nextTick(() => {
          // Emit a chart update event to force re-render
          this.$emit("chart-updated");
          
          // Emit scale values to ensure they are applied to the chart
          if (this.xAxisScale) {
            this.$emit("x-axis-scale", this.xAxisScale);
          }
          if (this.yAxisScale) {
            this.$emit("y-axis-scale", this.yAxisScale);
          }
        });
        
      } catch (error) {
        console.error('❌ Error during data extraction:', error);
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        this.$emit("sample-error", "Error processing chart data");
      }
    },
    // Method to process large datasets in chunks to prevent browser unresponsiveness
    async processLargeDataset(data, processFunction) {
      if (!data || data.length === 0) {
        return [];
      }
      
      // If data is small enough, process normally
      if (data.length <= this.dataChunkSize) {
        return processFunction(data);
      }
      
      this.isProcessingLargeData = true;
      this.processedDataCount = 0;
      
      const results = [];
      const totalChunks = Math.ceil(data.length / this.dataChunkSize);
      
      for (let i = 0; i < totalChunks; i++) {
        const start = i * this.dataChunkSize;
        const end = Math.min(start + this.dataChunkSize, data.length);
        const chunk = data.slice(start, end);
        
        // Process this chunk
        const chunkResult = processFunction(chunk);
        results.push(...chunkResult);
        
        // Update progress
        this.processedDataCount = end;
        
        // Allow browser to breathe between chunks
        if (i < totalChunks - 1) {
          await new Promise(resolve => setTimeout(resolve, 10));
        }
      }
      
      this.isProcessingLargeData = false;
      this.processedDataCount = 0;
      
      return results;
    },
    
    // Enhanced data extraction methods with chunking
    async findXAxisDataChunked() {
      if (!this.tableData || this.tableData.length === 0) {
        return [];
      }
      
      return await this.processLargeDataset(this.tableData, (chunk) => {
        return chunk.map(row => {
          const decimalKey = `${this.selectedXAxisKey}_decimal`;
          if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
            const value = parseFloat(row[this.selectedXAxisKey]);
            if (!isNaN(value)) {
              const maxDecimals = Math.min(row[decimalKey], 6);
              return value.toFixed(maxDecimals);
            }
          }
            return row[this.selectedXAxisKey];
        });
      });
    },
    
    async findYAxisDataChunked() {
      if (!this.tableData || this.tableData.length === 0) {
        return [];
      }
      
      return await this.processLargeDataset(this.tableData, (chunk) => {
        return this.selectedYAxisKey.map(col => {
          return chunk.map(row => {
            const decimalKey = `${col}_decimal`;
            if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
              const value = parseFloat(row[col]);
              if (!isNaN(value)) {
                const maxDecimals = Math.min(row[decimalKey], 6);
                return value.toFixed(maxDecimals);
              }
            }
              return row[col];
          });
        });
      });
    },
    
    async findZAxisDataChunked() {
      if (!this.tableData || this.tableData.length === 0) {
        return [];
      }
      
      return await this.processLargeDataset(this.tableData, (chunk) => {
        return chunk.map(row => {
          const decimalKey = `${this.selectedZAxisKey}_decimal`;
          if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
            const value = parseFloat(row[this.selectedZAxisKey]);
            if (!isNaN(value)) {
              const maxDecimals = Math.min(row[decimalKey], 6);
              return value.toFixed(maxDecimals);
            }
          }
          return row[this.selectedZAxisKey];
        });
      });
    },
    // Method to automatically fix column name mismatches
    autoFixColumnNames() {
      if (!this.tableData || !this.tableData.length) {
        return;
      }
      
      const firstRow = this.tableData[0];
      const availableKeys = Object.keys(firstRow);
      
      
      // Fix X-axis column name
      if (this.selectedXAxisKey && !(this.selectedXAxisKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedXAxisKey, availableKeys);
        if (fixedName) {
          this.selectedXAxisKey = fixedName;
        }
      }
      
      // Fix Y-axis column names
      if (this.selectedYAxisKey && this.selectedYAxisKey.length > 0) {
        this.selectedYAxisKey = this.selectedYAxisKey.map(col => {
          if (!(col in firstRow)) {
            const fixedName = this.findBestColumnMatch(col, availableKeys);
            if (fixedName) {
              return fixedName;
            }
          }
          return col;
        });
      }
      
      // Fix Z-axis column name
      if (this.selectedZAxisKey && !(this.selectedZAxisKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedZAxisKey, availableKeys);
        if (fixedName) {
          this.selectedZAxisKey = fixedName;
        }
      }
      
      // Fix color group column name
      if (this.selectedColorGroupKey && !(this.selectedColorGroupKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedColorGroupKey, availableKeys);
        if (fixedName) {
          this.selectedColorGroupKey = fixedName;
        }
      }
    },
    
    // Helper method to find the best column name match
    findBestColumnMatch(selectedName, availableKeys) {
  // Convert selectedName to an array if it isn't already
  const searchNames = Array.isArray(selectedName) 
    ? selectedName 
    : [selectedName];

  // Helper function to safely convert to lowercase (handles non-strings)
  const safeToLower = (str) => String(str || '').toLowerCase();

  // Try each search name in order until we find a match
  for (const name of searchNames) {
    const currentSearch = safeToLower(name);

    // 1. First try exact case-insensitive match
    const exactMatch = availableKeys.find(key => 
      safeToLower(key) === currentSearch
    );
    if (exactMatch) return exactMatch;

    // 2. Then try partial match
    const partialMatch = availableKeys.find(key => {
      const lowerKey = safeToLower(key);
      return (
        lowerKey.includes(currentSearch) ||
        currentSearch.includes(lowerKey)
      );
    });
    if (partialMatch) return partialMatch;

    // 3. Finally try removing special characters and matching
    const cleanSelected = currentSearch.replace(/[^a-zA-Z0-9]/g, '');
    const cleanMatch = availableKeys.find(key => {
      const cleanKey = safeToLower(key).replace(/[^a-zA-Z0-9]/g, '');
      return (
        cleanKey.includes(cleanSelected) || 
        cleanSelected.includes(cleanKey)
      );
    });
    if (cleanMatch) return cleanMatch;
  }

  // If no matches found after checking all names
  return null;
},
    
    // Method to populate form data when editing an existing plot
    populateEditData(editData) {
      
      if (!editData) return;
      
      // Set basic chart properties
      this.internalChartTitle = editData.chartName || '';
      this.selectedChartTypeName = editData.chartType || ''; // Use selectedChartTypeName instead of selectedChartType prop
      this.xBins = editData.xBins || 20;
      this.yBins = editData.yBins || 20;
      this.colorGroupKey = editData.colorGroupKey || '';
      this.xAxisScale = editData.xAxisScale || 'linear';
      this.yAxisScale = editData.yAxisScale || 'linear';
      this.isXLog = editData.xAxisScale === 'log';
      this.isYLog = editData.yAxisScale === 'log';
      
      // Set axis display names
      this.xAxisDisplayName = editData.xAxisDisplayName || '';
      this.yAxisDisplayNames = editData.yAxisDisplayNames || [];
      this.zAxisDisplayName = editData.zAxisDisplayName || '';
      
      // Set axis data
      this.xAxisData = editData.xAxisData || [];
      this.yAxisData = editData.yAxisData || [];
      this.zAxisData = editData.zAxisData || [];
      
      // Set color group data
      this.xColorGroupData = editData.xColorGroupData || {};
      this.yColorGroupData = editData.yColorGroupData || {};
      this.zColorGroupData = editData.zColorGroupData || {};
      
      // Set access level
      this.isPublic = editData.isShared || false;
      this.accessLevel = editData.isShared ? 'public' : 'private';
      
      // Emit the chart type change to parent
      this.$emit('chart-type-changed', this.selectedChartTypeName);
      
      // Emit the data to parent component
      this.$emit('x-axis-selected', { 
        data: this.xAxisData, 
        displayName: this.xAxisDisplayName, 
        caption: [] 
      });
      
      this.$emit('y-axis-selected', { 
        data: this.yAxisData, 
        displayNames: this.yAxisDisplayNames, 
        caption: [] 
      });
      
      if (this.zAxisData.length > 0) {
        this.$emit('z-axis-selected', { 
          data: this.zAxisData, 
          displayName: this.zAxisDisplayName 
        });
      }
      
      if (Object.keys(this.xColorGroupData).length > 0) {
        this.$emit('grouped-x-axis-data', this.xColorGroupData);
      }
      
      if (Object.keys(this.yColorGroupData).length > 0) {
        this.$emit('grouped-y-axis-data', this.yColorGroupData);
      }
      
      if (Object.keys(this.zColorGroupData).length > 0) {
        this.$emit('grouped-z-axis-data', this.zColorGroupData);
      }
      
      if (this.colorGroupKey) {
        this.$emit('color-group-key', this.colorGroupKey);
        
        // Emit color group display name
        const selectedColorGroupItem = this.colorGroupItems?.find(item => item.name === this.colorGroupKey);
        const colorGroupDisplayName = selectedColorGroupItem ? selectedColorGroupItem.displayName : this.colorGroupKey;
        this.$emit('color-group-display-name', colorGroupDisplayName);
      }
      
      this.$emit('x-axis-scale', this.xAxisScale);
      this.$emit('y-axis-scale', this.yAxisScale);
      this.$emit('chart-title', this.internalChartTitle);
      this.$emit('update-x-bins', this.xBins);
      this.$emit('update-y-bins', this.yBins);
      
    },
    
    // Handle delete plot in edit mode
    handleDeletePlotEdit() {
      if (confirm('Are you sure you want to delete this plot?')) {
        this.deleteChart();
        this.$emit('plot-deleted');
      }
    },
    
    // Handle save in edit mode
    handleSaveEditMode() {
      this.createLoading = true;
      
      // Use the existing createChart method
      this.createChart();
      
      // The createChart method will emit 'chart-saved-studio' when complete
      // We'll handle the completion in the parent component
    },
    // Method to process color group data for edit mode without making API calls
    processColorGroupDataForEditMode() {
      
      if (this.selectedColorGroupKey && this.selectedColorGroupKey.length > 0) {
        // Process the color grouping data
        this.colorGroupData = this.findcolorGroupData();
        
        if (this.colorGroupData && this.colorGroupData.length > 0) {
          
          // Initialize grouped data objects
          const groupedYAxisData = {};
          const groupedXAxisData = {};
          const groupedZAxisData = {};
          
          // Initialize the grouped arrays for each unique value
          this.colorGroupData.forEach(value => {
            groupedYAxisData[value] = [];
            groupedXAxisData[value] = [];
            groupedZAxisData[value] = [];
          });
          
          // Group the data
          this.tableData.forEach(row => {
            const colorGroupValue = row[this.selectedColorGroupKey];
            if (this.colorGroupData.includes(colorGroupValue)) {
              const yAxisRowData = this.selectedYAxisKey.map(key => {
                const decimalKey = `${key}_decimal`;
                if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
                  const value = parseFloat(row[key]);
                  if (!isNaN(value)) {
                    const maxDecimals = Math.min(row[decimalKey], 6);
                    return value.toFixed(maxDecimals);
                  }
                }
                return row[key];
              });
              groupedYAxisData[colorGroupValue].push(yAxisRowData);
              
              const xAxisRowData = row[this.selectedXAxisKey];
              groupedXAxisData[colorGroupValue].push(xAxisRowData);
              
              if (this.selectedZAxisKey) {
                const zAxisRowData = row[this.selectedZAxisKey];
                groupedZAxisData[colorGroupValue].push(zAxisRowData);
              }
            }
          });
          
          // Emit grouped data
          this.$emit("grouped-y-axis-data", groupedYAxisData);
          this.$emit("grouped-x-axis-data", groupedXAxisData);
          this.$emit("grouped-z-axis-data", groupedZAxisData);
          this.$emit("color-group-key", this.selectedColorGroupKey);
          
          // Emit color group display name
          const selectedColorGroupItem = this.colorGroupItems?.find(item => item.name === this.selectedColorGroupKey);
          const colorGroupDisplayName = selectedColorGroupItem ? selectedColorGroupItem.displayName : this.selectedColorGroupKey;
          this.$emit("color-group-display-name", colorGroupDisplayName);
          
          // Emit scale values to ensure they are applied to the chart
          if (this.xAxisScale) {
            this.$emit("x-axis-scale", this.xAxisScale);
          }
          if (this.yAxisScale) {
            this.$emit("y-axis-scale", this.yAxisScale);
          }
          
        } else {
          this.$emit("grouped-y-axis-data", { groupedYAxisData: [] });
          this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
          this.$emit("grouped-z-axis-data", { groupedZAxisData: [] });
        }
      } else {
        this.$emit("grouped-y-axis-data", { groupedYAxisData: [] });
        this.$emit("grouped-x-axis-data", { groupedXAxisData: [] });
        this.$emit("grouped-z-axis-data", { groupedZAxisData: [] });
      }
    },
  },
  async mounted() {
    
    // Set lastView to ensure filters work properly when creating charts
    localStorage.setItem("lastView", "/Fluidsdata-studio");
    
    this.isUpdateEnabled = this.checkIfUpdateEnabled();
    localStorage.removeItem("newsavedChartData");
    await this.getChartTypes();
    this.getTableTypes();
    this.getSavedCharts();
    
    
    const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
    const mainRoute = pathSegments.length > 1 ? pathSegments[1].toLowerCase() : null;

    if (mainRoute === 'fluidsdata-studio') {
      const savedChartData = localStorage.getItem("savedChartData");
      if (savedChartData) {
        const chartData = JSON.parse(savedChartData);
        if (chartData && chartData.ID) {
          this.selectedChartId = chartData.ID;
          this.savedChartChangeLoad(chartData);
        }
      } 
    }

    
  },
  beforeUnmount() {
    // Cancel all pending requests when component is destroyed
    this.cancelAllRequests();
  },
  beforeUnmount() {
    // Cancel all pending requests when component is unmounted (Vue 3 compatibility)
    this.cancelAllRequests();
  },
};
</script>

<style scoped>
.filter-wrapper.studio-new {
  width: 320px;
  min-width: 320px;
  max-width: 320px;
  background: #fff;
  border-right: 1px solid #e0e0e0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0,0,0,0.03);
  z-index: 2;
  overflow-y: auto;
  padding: 16px;
}

.text-truncate {
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: nowrap !important;
  max-width: none !important;
  min-width: 120px;
  display: block;
  font-size: 11.50px;
}

.v-select .v-field__input {
  overflow: visible !important;
}

.v-select .v-field__input .text-truncate {
  max-width: none !important;
  min-width: 100px;
  font-size: 11.50px;
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: nowrap !important;
}

.dropdown-item {
  width: 100%;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 11.50px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.dropdown-item .text-truncate {
  max-width: 100%;
  min-width: 120px;
  width: 100%;
  font-size: 11.50px;
}

.v-select .v-field__input {
  font-size: 11.50px;
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: nowrap !important;
}

/* Ensure v-select input can display full text */
.v-select .v-field__input input {
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: nowrap !important;
  max-width: none !important;
}

/* Ensure the v-select field itself can expand */
.v-select .v-field {
  min-width: 0 !important;
  flex: 1 !important;
}

.custom-field.v-select {
  min-width: 0 !important;
  flex: 1 !important;
}

.v-select .v-select__selection-text {
  font-size: 11.50px;
}

.v-list-item-title {
  font-size: 11.50px;
}

.dropdown-item .v-list-item-title {
  font-size: 11.50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Additional styling for form elements in sidebar */
.studio-btns {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.studio-btns .save-btn,
.studio-btns .delete-btn {
  flex: 1;
  height: 36px;
  font-size: 13.50px;
}

.tab-icon-div {
  margin-bottom: 16px;
}

.studio-input-form {
  width: 100%;
}

.studio-top-heading {
  margin-bottom: 16px;
}

.studio-top-heading h6 {
  font-size: 17.50px;
  font-weight: 600;
  color: #222;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .filter-wrapper.studio-new {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
  }
}

/* Slider styles for bins inputs */
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: #e0e0e0;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  margin-top: 8px;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1976d2;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1976d2;
  cursor: pointer;
  border: none;
}

/* Loader styles */
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}

.loaders {
  width: 20px !important;
  height: 20px !important;
}

/* Removed back button styles - now handled by top bar */

/* Form spacing styles */
.studio-input-form .v-col {
  margin-bottom: 8px;
}

.studio-input-form label {
  display: block;
  margin-bottom: 4px;
  font-size: 13.50px;
  font-weight: 500;
  color: #333;
}

.studio-input-form .custom-field {
  margin-bottom: 8px;
}

/* Scale toggle spacing */
.tab-div {
  margin-left: 8px;
  margin-bottom: 5px;
}

.axis-toggle {
  height: 32px;
}

.switch-btn {
  font-size: 11.50px;
  padding: 0 8px;
  min-width: 60px;
}
</style>